/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
  /** A unix timestamp integer representing seconds since epoch. */
  Timestamp: { input: any; output: any };
};

/** Attributes for accepting an invite */
export type AcceptInviteInput = {
  /** The id of the subscriber */
  subscriberId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptInvite */
export type AcceptInvitePayload = {
  __typename?: 'AcceptInvitePayload';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The saved subscriber. */
  subscriber?: Maybe<Subscriber>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
  from: Scalars['Timestamp']['output'];
  to: Scalars['Timestamp']['output'];
};

/** Represents a analytic overview metric. */
export type AnalyticsOverviewMetric = {
  __typename?: 'AnalyticsOverviewMetric';
  /** Number of new accounts created. */
  accountsCreated: Scalars['Int']['output'];
  /** Average prayer messages per session. */
  avgPrayerMessages: Scalars['Float']['output'];
  /** Average time attended in seconds. */
  avgTimeAttended: Scalars['Int']['output'];
  /** Number of offline prayer requests. */
  offlineRequests: Scalars['Int']['output'];
  /** Unique number of people with prayer requests. */
  prayerRequesters: Scalars['Int']['output'];
  /** Number of prayer requests. */
  prayerRequests: Scalars['Int']['output'];
  /** Number of prayer sessions accepted by one or more hosts. */
  prayerSessions: Scalars['Int']['output'];
  /** Total salvations. */
  salvations: Scalars['Int']['output'];
  /** The timepoint for the metrics. */
  timepoint: Scalars['ISO8601DateTime']['output'];
  /** Total time attended in seconds. */
  totalTimeAttended: Scalars['Int']['output'];
  /** Number of unique attenders. */
  uniqueAttenders: Scalars['Int']['output'];
  /** Number of unique attenders for the previous year. */
  uniqueAttendersPreviousYear: Scalars['Int']['output'];
  /** Number of unique Hosts. */
  uniqueHosts: Scalars['Int']['output'];
};

/** Results for analytics metrics overview */
export type AnalyticsOverviewMetrics = {
  __typename?: 'AnalyticsOverviewMetrics';
  /** The metrics for the specified timeframe. */
  activeMetrics: Array<AnalyticsOverviewMetric>;
  /** The metrics for the comparison timeframe. */
  comparisonMetrics: Array<AnalyticsOverviewMetric>;
  /** The grouping unit for the metric results. */
  groupingUnit: GroupingUnitType;
};

/** Attributes for creating or updating an Organization appearance. */
export type Appearance = {
  __typename?: 'Appearance';
  /** URL to the dark mode logo image. */
  darkLogo?: Maybe<Scalars['String']['output']>;
  /** Toggle for enabling dark mode. */
  enableDarkMode: Scalars['Boolean']['output'];
  /** URL to the Favicon image. */
  favicon?: Maybe<Scalars['String']['output']>;
  /** The color of the header background. */
  headerBackgroundColor: Scalars['String']['output'];
  /** The color of the header text. */
  headerTextColor: Scalars['String']['output'];
  /** Toggle for hiding viewership metric. */
  hideViewershipMetric: Scalars['Boolean']['output'];
  /** URL to the logo image. */
  logo?: Maybe<Scalars['String']['output']>;
  /** The style of navigation links. */
  navigationLinkCase: NavigationLinkOption;
  /** Dark or light mode for the organization. */
  visualMode: VisualModeOption;
};

/** Attributes for creating or updating an Organization appearance. */
export type AppearanceInput = {
  /** URL to the dark mode logo image. */
  darkLogo?: InputMaybe<Scalars['String']['input']>;
  /** Toggle for enabling dark mode. */
  enableDarkMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to the Favicon image. */
  favicon?: InputMaybe<Scalars['String']['input']>;
  /** The color of the header background. */
  headerBackgroundColor: Scalars['String']['input'];
  /** The color of the header text. */
  headerTextColor: Scalars['String']['input'];
  /** Toggle for hiding viewership metric. */
  hideViewershipMetric?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to the logo image. */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** The style of navigation links. */
  navigationLinkCase: NavigationLinkOption;
  /** Dark or light mode for the organization. */
  visualMode?: InputMaybe<VisualModeOption>;
};

/** Flags for determining how to apply service time changes */
export enum ApplyEnum {
  /** save/update the service_time or delete all services with the service_time */
  ALL = 'ALL',
  /** create a new service_time and assign it to the service or delete the service */
  CURRENT = 'CURRENT',
  /** create a new service_time and split the services going forward or delete all future services */
  FUTURE = 'FUTURE',
}

/** Attributes for creating or updating areas of ministry. */
export type AreaOfMinistriesInput = {
  /** The id of the Area of Ministry */
  id: Scalars['ID']['input'];
  /** The key of the Area of Ministry */
  key: Scalars['String']['input'];
  /** The label of the Area of Ministry */
  label: Scalars['String']['input'];
};

/** Represents an Area of Ministry */
export type AreaOfMinistry = {
  __typename?: 'AreaOfMinistry';
  /** The id of the Area of Ministry */
  id: Scalars['ID']['output'];
  /** The key of the Area of Ministry */
  key: Scalars['String']['output'];
  /** The label of the Area of Ministry */
  label: Scalars['String']['output'];
};

/** Represents a response with a job */
export type BackgroundResponse = {
  __typename?: 'BackgroundResponse';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The job that is running */
  job: Job;
};

export type BaseConnectionInterface = {
  aggregate: Aggregate;
};

/** Attributes for changing a password */
export type ChangePasswordInput = {
  /** Password confirmation input */
  confirmNewPassword: Scalars['String']['input'];
  /** New password input */
  newPassword: Scalars['String']['input'];
  /** Old password input */
  oldPassword: Scalars['String']['input'];
};

/** Represents a Pubnub channel that content can be delivered on. */
export type Channel = {
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  /** Type of Channel. */
  type: ChannelType;
};

/** Return value for Channel Input Request. */
export type ChannelInput = {
  /** The id for the channel, must be a UUID. */
  id: Scalars['ID']['input'];
  /** Meta data for request channel. */
  meta?: InputMaybe<ChannelInputMeta>;
  /** Origin of the channel. */
  origin?: InputMaybe<ChannelOrigin>;
  /** The service that the channel is associated to. */
  serviceId: Scalars['ID']['input'];
  /** Type of channel. */
  type: ChannelType;
};

/** Meta data for request channel. */
export type ChannelInputMeta = {
  /** Whether or not the subscriber just raised their hand. */
  raisedHand?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The format of the channel key. */
export enum ChannelKeyFormat {
  /** The new format for the channel key. This is the new format which includes a subscriber id. */
  NEW = 'NEW',
  /** The old format for the channel key. This is the default format which does not include a subscriber id. */
  OLD = 'OLD',
}

/** The origin of the channel. */
export enum ChannelOrigin {
  /** The channel was requested from the prayer landing page. */
  LANDING = 'LANDING',
  /** The channel was requested from the service experience. */
  SERVICE = 'SERVICE',
}

export enum ChannelType {
  command = 'command',
  direct = 'direct',
  host = 'host',
  message_action = 'message_action',
  moment = 'moment',
  personal = 'personal',
  prayer = 'prayer',
  public = 'public',
  reaction = 'reaction',
}

export type CommandChannel = Channel & {
  __typename?: 'CommandChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  /** Type of Channel. */
  type: ChannelType;
};

/** Represents the channels and grant token for a service and authorized user. */
export type Communication = {
  __typename?: 'Communication';
  /** The channels that the user has access to. */
  channels: Array<Channel>;
  /** The grant token for the channels. */
  grantToken?: Maybe<Scalars['String']['output']>;
};

/** Represents a Connect Moment. */
export type ConnectMoment = {
  __typename?: 'ConnectMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the connect moment. */
  options: ConnectMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of a connect moment. */
export type ConnectMomentInstance = MomentInstance & {
  __typename?: 'ConnectMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ConnectMomentOptions = {
  __typename?: 'ConnectMomentOptions';
  /** The copy text. */
  text: Scalars['String']['output'];
  /** The connect url. */
  url: Scalars['String']['output'];
  /** How to open the connect url. */
  windowType: WindowType;
};

export type ConnectionInterface = {
  aggregate: Aggregate;
};

/** Represents a particular instance of a service's content. */
export type Content = {
  __typename?: 'Content';
  /** The chat end offset of the service. */
  chatEndOffset?: Maybe<Scalars['Int']['output']>;
  /** The chat start offset of the service. */
  chatStartOffset?: Maybe<Scalars['Int']['output']>;
  /** The duration of the content. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** The features of the service. */
  features?: Maybe<ContentFeatures>;
  /** Whether or not the content has a video. */
  hasVideo: Scalars['Boolean']['output'];
  /** The content's host info. */
  hostInfo?: Maybe<Scalars['String']['output']>;
  /** The id of the content. */
  id: Scalars['ID']['output'];
  /** The scheduled moments for the provided content. */
  momentScheduleItems: Array<MomentScheduleItem>;
  /** The content's notes. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The share image of the content. */
  shareImage?: Maybe<Scalars['String']['output']>;
  /** The title of the content. */
  title: Scalars['String']['output'];
  /** The version history for this content. */
  versions: Array<Version>;
  /** The video for the content ID. If the videoStarted is false returns null. */
  video?: Maybe<Video>;
  /** The video start offset of the service. */
  videoStartOffset?: Maybe<Scalars['Int']['output']>;
  /** The video's start time. */
  videoStartTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Whether or not the video has started. */
  videoStarted?: Maybe<Scalars['Boolean']['output']>;
};

/** The connection type for Content. */
export type ContentConnection = {
  __typename?: 'ContentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

/** Represents the features a particular service has. */
export type ContentFeatures = {
  __typename?: 'ContentFeatures';
  /** Whether or not the service has live prayer. */
  livePrayer?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the service has public chat. */
  publicChat?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the features a particular service has. */
export type ContentFeaturesInput = {
  /** Whether or not the service has live prayer. */
  livePrayer: Scalars['Boolean']['input'];
  /** Whether or not the service has public chat. */
  publicChat: Scalars['Boolean']['input'];
};

/** Represents a particular instance of an organization's content. */
export type ContentInput = {
  /** The chat end offset of the service. */
  chatEndOffset?: InputMaybe<Scalars['Int']['input']>;
  /** The chat start offset of the service. */
  chatStartOffset?: InputMaybe<Scalars['Int']['input']>;
  /** The duration of the content. */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** The features of the service. */
  features?: InputMaybe<ContentFeaturesInput>;
  /** The content's host info. */
  hostInfo?: InputMaybe<Scalars['String']['input']>;
  /** The id of the content. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The content's notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The services to map the content to. */
  services: Array<ServiceInput>;
  /** The share image of the content. */
  shareImage?: InputMaybe<Scalars['String']['input']>;
  /** The title of the service. */
  title: Scalars['String']['input'];
  /** The video for the service. */
  video?: InputMaybe<ContentVideo>;
  /** The video start offset of the service. */
  videoStartOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents video input. */
export type ContentVideo = {
  /** The id of the video. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The video's data. */
  input: VideoInput;
};

/** Autogenerated return type of DeleteIdentities */
export type DeleteIdentitiesPayload = {
  __typename?: 'DeleteIdentitiesPayload';
  errors: Array<Error>;
  identities: Array<IdentityResponse>;
};

/** Autogenerated return type of DeleteIntegration */
export type DeleteIntegrationPayload = {
  __typename?: 'DeleteIntegrationPayload';
  /** A list of errors that occurred while deleting. */
  errors: Array<Error>;
  /** The deleted Integration. */
  integration?: Maybe<Integration>;
};

/** Attributes for deleting a Moment Instance. */
export type DeleteMomentInstanceInput = {
  /** The unique ID of the Moment Instance. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMomentInstance */
export type DeleteMomentInstancePayload = {
  __typename?: 'DeleteMomentInstancePayload';
  /** A list of errors that occurred while deleting. */
  errors: Array<Error>;
  /** The deleted Moment Instance */
  momentInstance?: Maybe<MomentInstance>;
};

/** Autogenerated return type of DeleteMomentTemplate */
export type DeleteMomentTemplatePayload = {
  __typename?: 'DeleteMomentTemplatePayload';
  /** A list of errors that occurred while deleting. */
  errors: Array<Error>;
  /** The deleted Moment Template. */
  momentTemplate?: Maybe<MomentTemplate>;
};

/** Autogenerated return type of DeleteOrganization */
export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  /** A list of errors that occured when trying to delete the organization. */
  errors: Array<Error>;
  /** The deleted Organization. */
  organization?: Maybe<Organization>;
};

/** Autogenerated return type of DeleteService */
export type DeleteServicePayload = {
  __typename?: 'DeleteServicePayload';
  errors: Array<Error>;
  service?: Maybe<Service>;
};

/** Autogenerated return type of DeleteSubscriber */
export type DeleteSubscriberPayload = {
  __typename?: 'DeleteSubscriberPayload';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The deleted subscriber */
  subscriber?: Maybe<Subscriber>;
};

/** Autogenerated return type of DeleteVideo */
export type DeleteVideoPayload = {
  __typename?: 'DeleteVideoPayload';
  /** A list of errors that occurred while deleting. */
  errors: Array<Error>;
  /** The deleted Video. */
  video?: Maybe<Video>;
};

/** Autogenerated return type of DeleteWebhook */
export type DeleteWebhookPayload = {
  __typename?: 'DeleteWebhookPayload';
  /** A list of errors that occurred while deleting. */
  errors: Array<Error>;
  /** The deleted Webhook. */
  webhook?: Maybe<Webhook>;
};

export type DirectChannel = Channel & {
  __typename?: 'DirectChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  subscribers: SubscriberConnection;
  /**
   * Load all subscribers in a given channel (DEPRECATED)
   * @deprecated Removing in favor of channel { subscribers } using connection type
   */
  subscribersDep: Array<Subscriber>;
  /** Type of Channel. */
  type: ChannelType;
};

export type DirectChannelSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubscribersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum EmailConsentType {
  /** Ask all users if they consent to be emailed. */
  ALL = 'ALL',
  /** Only ask EU users if they consent to be emailed. */
  EU = 'EU',
  /** Do not ask any user for consent to be emailed, */
  OFF = 'OFF',
}

/** Represents an error within the system */
export type Error = {
  __typename?: 'Error';
  /** The error code */
  code: Scalars['String']['output'];
  /** The error message */
  message?: Maybe<Scalars['String']['output']>;
  /** The property the error occurred on */
  property?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ExportUsers */
export type ExportUsersPayload = {
  __typename?: 'ExportUsersPayload';
  /** The URL to download exported users as a csv file. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The errors that occurred. */
  errors: Array<Error>;
};

/** Autogenerated return type of ExtendServices */
export type ExtendServicesPayload = {
  __typename?: 'ExtendServicesPayload';
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

/** Represents a Facebook App Integration. */
export type FacebookApp = Integration & {
  __typename?: 'FacebookApp';
  /** The config for a Facebook App Integration. */
  config: FacebookAppConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FacebookAppConfig = {
  __typename?: 'FacebookAppConfig';
  /** The App ID for the Facebook App Integration. */
  appId: Scalars['String']['output'];
  /** The App Secret for the Facebook App Integration. */
  appSecret?: Maybe<Scalars['String']['output']>;
};

/** Represents a Facebook Pixel Integration. */
export type FacebookPixel = Integration & {
  __typename?: 'FacebookPixel';
  /** The config for a Facebook Pixel Integration. */
  config: FacebookPixelConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FacebookPixelConfig = {
  __typename?: 'FacebookPixelConfig';
  /** The Pixel ID for the Facebook Pixel Integration. */
  pixelId: Scalars['String']['output'];
};

/** Represents a Front Integration. */
export type Front = Integration & {
  __typename?: 'Front';
  /** The config for a Front Integration. */
  config: FrontConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FrontConfig = {
  __typename?: 'FrontConfig';
  /** The Chat ID for the Front chat script. */
  frontId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of GenerateDefaultMomentTemplates */
export type GenerateDefaultMomentTemplatesPayload = {
  __typename?: 'GenerateDefaultMomentTemplatesPayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The default Moment Templates. */
  momentTemplates: Array<MomentTemplate>;
};

/** Represents a Giving Moment. */
export type GivingMoment = {
  __typename?: 'GivingMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the giving moment. */
  options: GivingMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of a giving moment. */
export type GivingMomentInstance = MomentInstance & {
  __typename?: 'GivingMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type GivingMomentOptions = {
  __typename?: 'GivingMomentOptions';
  /** The giving src. */
  src: Scalars['String']['output'];
  /** The copy text. */
  text: Scalars['String']['output'];
  /** How to open the giving src. */
  windowType: WindowType;
};

/** Represents a Gloo Integration. */
export type Gloo = Integration & {
  __typename?: 'Gloo';
  /** The config for a Gloo Integration. */
  config: GlooConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GlooConfig = {
  __typename?: 'GlooConfig';
  /** The Gloo ID for the Gloo Integration. */
  glooId: Scalars['String']['output'];
};

/** Represents a Google Analytics Integration. */
export type GoogleAnalytics = Integration & {
  __typename?: 'GoogleAnalytics';
  /** The config for a Google Analytics Integration. */
  config: GoogleAnalyticsConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents a Google Analytics 4 Integration. */
export type GoogleAnalytics4 = Integration & {
  __typename?: 'GoogleAnalytics4';
  /** The config for a Google Analytics 4 Integration. */
  config: GoogleAnalytics4Config;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GoogleAnalytics4Config = {
  __typename?: 'GoogleAnalytics4Config';
  /** The Tracking ID for the Google Analytics 4 Integration. */
  trackingId: Scalars['String']['output'];
};

export type GoogleAnalyticsConfig = {
  __typename?: 'GoogleAnalyticsConfig';
  /** The Tracking ID for the Google Analytics Integration. */
  trackingId: Scalars['String']['output'];
};

/** Represents a Google Sheets Integration. */
export type GoogleSheets = Integration & {
  __typename?: 'GoogleSheets';
  /** The config for a Google Analytics Integration. */
  config: GoogleSheetsConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GoogleSheetsConfig = {
  __typename?: 'GoogleSheetsConfig';
  /** The Destination for the Google Sheets Integration. */
  destinations: Array<GoogleSheetsDestination>;
  /** The Email Address for the Google Sheets Integration. */
  emailAddress: Scalars['String']['output'];
  /** The Status for the Google Sheets Integration. */
  status: GoogleSheetsStatusType;
};

export type GoogleSheetsDestination = {
  __typename?: 'GoogleSheetsDestination';
  /** The Active Sheet Id for the Google Sheets Integration. */
  activeSheetId?: Maybe<Scalars['ID']['output']>;
  /** The last time the sync occured for the Google Sheets Integration. */
  lastSync?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Destination Type for the Google Sheets Integration. */
  type: GoogleSheetsDestinationType;
};

/** Destination attributes for Google Sheets integration. */
export type GoogleSheetsDestinationInput = {
  /** The Active Sheet Id for the Google Sheets Integration. */
  activeSheetId?: InputMaybe<Scalars['ID']['input']>;
  /** The last time the sync occured for the Google Sheets Integration. */
  lastSync?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The Destination Type for the Google Sheets Integration. */
  type: GoogleSheetsDestinationType;
};

export enum GoogleSheetsDestinationType {
  USER_EXPORT = 'USER_EXPORT',
}

export enum GoogleSheetsStatusType {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}

/** Represents a Google Tag Manager Integration. */
export type GoogleTagManager = Integration & {
  __typename?: 'GoogleTagManager';
  /** The config for a Google Tag Manager Integration. */
  config: GoogleTagManagerConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GoogleTagManagerConfig = {
  __typename?: 'GoogleTagManagerConfig';
  /** The Container ID for the Google Tag Manager Integration. */
  containerId: Scalars['String']['output'];
};

export enum GroupingUnitType {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export type HostChannel = Channel & {
  __typename?: 'HostChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  subscribers: SubscriberConnection;
  /** Type of Channel. */
  type: ChannelType;
};

export type HostChannelSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubscribersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a HubSpot Integration. */
export type HubSpot = Integration & {
  __typename?: 'HubSpot';
  /** The config for a HubSpot Integration. */
  config: HubSpotConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type HubSpotConfig = {
  __typename?: 'HubSpotConfig';
  /** The Tracking Code ID for the HubSpot Integration. */
  trackingCodeId: Scalars['String']['output'];
};

/** Attributes for creating or updating an identity */
export type IdentityInput = {
  /** The email of the identity */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Email verified indicator */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the identity has global authentication */
  globalAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether or not the identity is setting up a new organization */
  newOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the organization */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The password of the identity */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Overrides whether or not to send the verification email when valid criteria are met */
  sendVerificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the subscriber */
  subscriberId: Scalars['ID']['input'];
  /** Type type of the identity. Defaults to BasicAuth */
  type?: InputMaybe<IdentityType>;
};

/** Response that represents an Identity model */
export type IdentityResponse = {
  __typename?: 'IdentityResponse';
  id: Scalars['ID']['output'];
  jwt?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  subscriberId: Scalars['ID']['output'];
  type: IdentityType;
  uid?: Maybe<Scalars['String']['output']>;
};

/** Identity Type enums */
export enum IdentityType {
  BASIC = 'BASIC',
  FACEBOOK = 'FACEBOOK',
  GUEST = 'GUEST',
  LEGACY = 'LEGACY',
  OPENID_CONNECT = 'OPENID_CONNECT',
  SERVICE = 'SERVICE',
  SIGNUP = 'SIGNUP',
  TEMP = 'TEMP',
}

/** Represents an Image Moment. */
export type ImageMoment = {
  __typename?: 'ImageMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the image moment. */
  options: ImageMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of an image moment. */
export type ImageMomentInstance = MomentInstance & {
  __typename?: 'ImageMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ImageMomentOptions = {
  __typename?: 'ImageMomentOptions';
  /** The alt-text of the image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The image url. */
  imageUrl: Scalars['String']['output'];
  /** The share text of the image. */
  shareText?: Maybe<Scalars['String']['output']>;
};

/** Represents an Integration */
export type Integration = {
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Configuration attributes for creating or updating an Integration. */
export type IntegrationConfigInput = {
  /** The Account ID for Osano. */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** The App ID for Facebook App. */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** The App Secret for Facebook App. */
  appSecret?: InputMaybe<Scalars['String']['input']>;
  /** The Client ID for Open ID Connect. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The Cliente Secret for Open ID Connect. */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** The Config ID for Osano. */
  configId?: InputMaybe<Scalars['String']['input']>;
  /** The Container ID for Google Tag Manager. */
  containerId?: InputMaybe<Scalars['String']['input']>;
  /** The Destination for the Google Sheets Integration. */
  destinations?: InputMaybe<Array<GoogleSheetsDestinationInput>>;
  /** The Email Address for Google Sheets. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** The chat ID for Front */
  frontId?: InputMaybe<Scalars['String']['input']>;
  /** The Gloo ID. */
  glooId?: InputMaybe<Scalars['String']['input']>;
  /** The Issuer URI for Open ID Connect. */
  issuerUri?: InputMaybe<Scalars['String']['input']>;
  /** The Pixel ID for Facebook Pixel. */
  pixelId?: InputMaybe<Scalars['String']['input']>;
  /** The segment domain */
  segmentDomain?: InputMaybe<Scalars['String']['input']>;
  /** The segment key */
  segmentKey?: InputMaybe<Scalars['String']['input']>;
  /** The Stack Adapt ID */
  stackAdaptId?: InputMaybe<Scalars['String']['input']>;
  /** The Status for the Google Sheets Integration. */
  status?: InputMaybe<GoogleSheetsStatusType>;
  /** The Tracking Code ID for HubSpot. */
  trackingCodeId?: InputMaybe<Scalars['String']['input']>;
  /** The Tracking ID for Google Analytics. */
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating or updating an Integration. */
export type IntegrationInput = {
  /** The configuration for the Integration. */
  config: IntegrationConfigInput;
  /** Integration enabled status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique ID of the Integration. */
  id: Scalars['ID']['input'];
  /** The type of Integration. */
  type: IntegrationType;
};

export type IntegrationSearchFilter = {
  /** logically or another filter */
  OR?: InputMaybe<Array<IntegrationSearchFilter>>;
  /** filter on enabled or not */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** integration type should equal */
  typeEq?: InputMaybe<IntegrationType>;
  /** integration type should be in */
  typeIn?: InputMaybe<Array<IntegrationType>>;
};

export enum IntegrationType {
  FACEBOOK_APP = 'FACEBOOK_APP',
  FACEBOOK_PIXEL = 'FACEBOOK_PIXEL',
  FRONT = 'FRONT',
  GLOO = 'GLOO',
  GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
  GOOGLE_ANALYTICS_4 = 'GOOGLE_ANALYTICS_4',
  GOOGLE_SHEETS = 'GOOGLE_SHEETS',
  GOOGLE_TAG_MANAGER = 'GOOGLE_TAG_MANAGER',
  HUBSPOT = 'HUBSPOT',
  LEGACY_AUTH = 'LEGACY_AUTH',
  OPEN_ID_CONNECT = 'OPEN_ID_CONNECT',
  OSANO = 'OSANO',
  SEGMENT = 'SEGMENT',
  STACK_ADAPT = 'STACK_ADAPT',
  WEBHOOKS_INTEGRATION = 'WEBHOOKS_INTEGRATION',
}

/** Represents an Invite Moment. */
export type InviteMoment = {
  __typename?: 'InviteMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the invite moment. */
  options: InviteMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of an invite moment. */
export type InviteMomentInstance = MomentInstance & {
  __typename?: 'InviteMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type InviteMomentOptions = {
  __typename?: 'InviteMomentOptions';
  /** The button copy text. */
  buttonText: Scalars['String']['output'];
  /** The copy text. */
  text: Scalars['String']['output'];
};

/** Attributes for inviting a user. */
export type InviteUserInput = {
  /** The user email */
  email: Scalars['String']['input'];
  /** The type of role */
  roleId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of role identifier */
  roleIdentifierId?: InputMaybe<Scalars['ID']['input']>;
  /** The user to invite */
  subscriberId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of InviteUser */
export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The subscriber that was created. */
  subscriber?: Maybe<Subscriber>;
};

/** Represents Sidekiq job information */
export type Job = {
  __typename?: 'Job';
  id: Scalars['ID']['output'];
};

export type JobInterface = {
  at?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  percentComplete?: Maybe<Scalars['Int']['output']>;
  status: JobStatus;
  total?: Maybe<Scalars['Int']['output']>;
  updateTime: Scalars['ISO8601DateTime']['output'];
};

export enum JobStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RETRYING = 'RETRYING',
  WORKING = 'WORKING',
}

/** Represents Sidekiq job success result */
export type JobSuccess = {
  __typename?: 'JobSuccess';
  errors: Array<Error>;
  job?: Maybe<Job>;
};

/** Represents a Legacy Auth Integration. */
export type LegacyAuth = Integration & {
  __typename?: 'LegacyAuth';
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents a navigation link for an organization */
export type Link = {
  __typename?: 'Link';
  /** If it is a default link */
  default: Scalars['Boolean']['output'];
  /** The id of the link */
  id: Scalars['ID']['output'];
  /** The unique ID for the link */
  key: Scalars['String']['output'];
  /** The Label for the link */
  label: Scalars['String']['output'];
};

/** Attributes for adding/editing a navigation link for an organization */
export type LinkInput = {
  /** The Label for the link. */
  label: Scalars['String']['input'];
  /** The URL to send the user to. */
  url: Scalars['String']['input'];
};

/** Represents the login banner for an organization. */
export type LoginBanner = {
  __typename?: 'LoginBanner';
  /** The body text of the login banner. */
  bodyText?: Maybe<Scalars['String']['output']>;
  /** The text of the button on the login banner. */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Whether the login banner is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** Attributes for creating or updating a LoginBanner. */
export type LoginBannerInput = {
  /** The body text of the login banner. */
  bodyText: Scalars['String']['input'];
  /** The text of the button on the login banner. */
  buttonText: Scalars['String']['input'];
  /** Whether the login banner is enabled. */
  enabled: Scalars['Boolean']['input'];
};

export type MessageActionChannel = Channel & {
  __typename?: 'MessageActionChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  /** Type of Channel. */
  type: ChannelType;
};

/** Input fields for a MessageAction */
export type MessageActionInput = {
  /** The channel_id of the message being acted upon */
  channelId: Scalars['ID']['input'];
  /** The id of the message action */
  id: Scalars['ID']['input'];
  /** The message_id of the message being acted upon */
  messageId: Scalars['ID']['input'];
  /** The type of message action */
  type: MessageActionType;
};

export enum MessageActionType {
  LIKE = 'LIKE',
}

/** The channel object on for a message. */
export type MessageChannelInput = {
  /** Whether or not the channel is 1-1. */
  direct: Scalars['Boolean']['input'];
  /** The id of the channel. */
  id: Scalars['ID']['input'];
  /** The key of the channel. */
  key: Scalars['String']['input'];
  /** The name of the channel. */
  name: Scalars['String']['input'];
  /** The type of the channel. */
  type: ChannelType;
};

/** The channel object on for a message. */
export type MessageInput = {
  /** The channel the message is shown on. */
  channel: MessageChannelInput;
  /** Whether or not the message is deleted. */
  deleted: Scalars['Boolean']['input'];
  /** The id of message. */
  id: Scalars['ID']['input'];
  /** The source language of the message. */
  lang: Scalars['String']['input'];
  /** The id of the subscriber who send the message. */
  subscriberId: Scalars['ID']['input'];
  /** The message text. */
  text: Scalars['String']['input'];
  /** The time the message was published. */
  timestamp: Scalars['ISO8601DateTime']['input'];
  /** An array of translations for a message. */
  translations: Array<MessageTranslationInput>;
};

/** A translation of a message into another language. */
export type MessageTranslationInput = {
  /** The language code for the translation. */
  languageCode: Scalars['String']['input'];
  /** The translated text representation. */
  text: Scalars['String']['input'];
};

/** Metrics for analytics overview inputs */
export type MetricsForAnalyticsOverviewInput = {
  /** Starting time period */
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Ending time period */
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Attributes for Moment Instances Inputs */
export type MetricsForMomentInstancesInput = {
  /** Moment Instance ids for the metrics to be retreived. */
  momentInstanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Attributes for Service Inputs */
export type MetricsForServicesInput = {
  /** Service ids for the metrics to be retreived. */
  serviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a moment action. */
export type MomentAction = {
  __typename?: 'MomentAction';
  /** The type of the moment action. */
  actionType: MomentActionType;
  /** The id of the moment action. */
  id: Scalars['ID']['output'];
  /** The ID for the moment instance of the moment action. */
  momentInstanceId: Scalars['ID']['output'];
};

/** Attributes for creating or updating a Moment Action. */
export type MomentActionInput = {
  /** The type of action. */
  actionType: MomentActionType;
  /** The unique ID of the Moment Action. */
  id: Scalars['ID']['input'];
  /** The ID of the Moment Instance. */
  momentInstanceId: Scalars['ID']['input'];
};

export enum MomentActionType {
  LIKE = 'LIKE',
  SHARE = 'SHARE',
  SUBMIT = 'SUBMIT',
}

export type MomentChannel = Channel & {
  __typename?: 'MomentChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  /** Type of Channel. */
  type: ChannelType;
};

/** Represents an instance of a moment. */
export type MomentInstance = {
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating or updating a Moment Instance. */
export type MomentInstanceInput = {
  /** Used by Scheduled Moments to indicate if the job should be deleted after completed. */
  deleteJob?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the Destination Channel. */
  destinationChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** The unique ID of the Moment Instance. */
  id: Scalars['ID']['input'];
  /** The ID of the Moment Template */
  momentTemplateId: Scalars['ID']['input'];
  /** The post time for the moment, defaults to server time. Used by scheduler to pre-deliver moments. */
  postTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The ID of the Service */
  serviceId: Scalars['ID']['input'];
  /** The trigger source of the moment instance. */
  trigger?: InputMaybe<MomentTriggerType>;
};

/** Represents an Moment Instance Metric. */
export type MomentInstanceMetric = {
  __typename?: 'MomentInstanceMetric';
  /** Total number of moment views for the instances */
  impressions: Scalars['Int']['output'];
  /** Total number of moment actions for the instances */
  interactions: Scalars['Int']['output'];
  /** Total number of moment actions of type LIKE */
  likes: Scalars['Int']['output'];
  /** The ID of the moment instance */
  momentInstanceId: Scalars['ID']['output'];
  /** Total number of moment actions of type SHARE */
  shares: Scalars['Int']['output'];
  /** Total number of moment actions of type SUBMIT */
  submissions: Scalars['Int']['output'];
};

/** Represents a scheduled moment. */
export type MomentScheduleItem = {
  __typename?: 'MomentScheduleItem';
  /** The content the scheduled moment belongs to. */
  contentId: Scalars['ID']['output'];
  /** The id of the moment schedule item. */
  id: Scalars['ID']['output'];
  /** The moment template of the scheduled moment. */
  momentTemplate: MomentTemplate;
  /**
   * The scheduled moments ordinality, if null, the moment is automatically
   * scheduled, and start time offset should be used for ordering.
   */
  ordinal?: Maybe<Scalars['Int']['output']>;
  /** The organization the scheduled moment belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The scheduled offset of the moment. If null, the moment can be manually posted. */
  startTimeOffset?: Maybe<Scalars['Int']['output']>;
};

/** Attributes for creating a moment schedule item. */
export type MomentScheduleItemInput = {
  /** The unique ID of the Moment Schedule Item. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The Id of the moment template to associate to. */
  momentTemplateId: Scalars['ID']['input'];
  /** The scheduled moments ordinality */
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  /** The scheduled offset of the moment. If null, the moment can be manually posted. */
  startTimeOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes required to update a service. */
export type MomentServiceInput = {
  /** The ID of the content. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the service. */
  id: Scalars['ID']['input'];
  /** The domain of the organization for scheduling. Will override Current.application domain if it exists. */
  organizationDomain?: InputMaybe<Scalars['String']['input']>;
  /** The id of the organization the service belongs to. */
  organizationId: Scalars['ID']['input'];
  /** The start time for the service. */
  startTime: Scalars['ISO8601DateTime']['input'];
};

/** Moment Templates */
export type MomentTemplate =
  | ConnectMoment
  | GivingMoment
  | ImageMoment
  | InviteMoment
  | NextStepsMoment
  | PrayerMoment
  | QuoteMoment
  | ResponseMoment
  | SalvationMoment;

/** Attributes for creating or updating a Moment Template. */
export type MomentTemplateInput = {
  /** The unique ID of the Moment Template. */
  id: Scalars['ID']['input'];
  /** If this moment is included in future services. */
  includedInFutureServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The options for the Moment Template. */
  options: MomentTemplateOptionsInput;
  /** The type of the Moment Template. */
  type: MomentType;
};

/** Options attributes for creating or updating a Moment Template. */
export type MomentTemplateOptionsInput = {
  /** The alt-text of the image. */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** The attribution for the quote. */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** The button text for the moment. */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** A description for the next steps moment. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The icon URL for the next steps moment. */
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** The image url. */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The custom labels assigned to the moment */
  labels?: InputMaybe<MomentTemplateOptionsLabelsInput>;
  /** The lead-in text for the next steps moment. */
  leadInText?: InputMaybe<Scalars['String']['input']>;
  /** Method of following up a salvation moment */
  salvationMomentFollowUpType?: InputMaybe<SalvationMomentFollowUpType>;
  /** The share text of the image. */
  shareText?: InputMaybe<Scalars['String']['input']>;
  /** The giving source. */
  src?: InputMaybe<Scalars['String']['input']>;
  /** The symbol for the moment. */
  symbol?: InputMaybe<SymbolInput>;
  /** The text for the moment. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** The url for the moment */
  url?: InputMaybe<Scalars['String']['input']>;
  /** How to open the giving src. */
  windowType?: InputMaybe<WindowType>;
};

/** Labels for creating or updating a Moment Template. */
export type MomentTemplateOptionsLabelsInput = {
  /** The button text */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** The celebration message */
  celebrationMessage?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

export enum MomentTriggerType {
  SCHEDULER = 'SCHEDULER',
  USER = 'USER',
}

export enum MomentType {
  CONNECT = 'CONNECT',
  GIVING = 'GIVING',
  IMAGE = 'IMAGE',
  INVITE = 'INVITE',
  NEXT_STEPS = 'NEXT_STEPS',
  PRAYER = 'PRAYER',
  QUOTE = 'QUOTE',
  RESPONSE = 'RESPONSE',
  SALVATION = 'SALVATION',
  SIGNUP = 'SIGNUP',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept invite with the given input */
  acceptInvite: AcceptInvitePayload;
  /** Updates the channel invite and joins the channel. */
  acceptInviteToChannel: PrivateChannelInvite;
  addLanguageToChannel: Success;
  addLanguageToChannelDep: Scalars['Boolean']['output'];
  addLanguageToChannels: Success;
  addLanguageToChannelsDep: Scalars['Boolean']['output'];
  /** Change password with the given input */
  changePassword: Success;
  /** Delete identities with the given subscriber_id */
  deleteIdentities: DeleteIdentitiesPayload;
  /** Delete identities with the given subscriber_id */
  deleteIdentitiesDep: Success;
  /** Deletes an Integration. */
  deleteIntegration: DeleteIntegrationPayload;
  /** Publish the provided message as deleted. */
  deleteMessage: Success;
  /** Delete a Moment Instance. */
  deleteMomentInstance: DeleteMomentInstancePayload;
  /** Delete a Moment Template. */
  deleteMomentTemplate: DeleteMomentTemplatePayload;
  /** Delete an Organization. */
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  /** Delete a service */
  deleteService: DeleteServicePayload;
  /** Delete a service */
  deleteServiceDep: Success;
  /** Delete the subscriber with the given id */
  deleteSubscriber: DeleteSubscriberPayload;
  /** Delete the subscriber with the given id */
  deleteSubscriberDep: Success;
  /** Deletes a video */
  deleteVideo: DeleteVideoPayload;
  /** Deletes a Webhook. */
  deleteWebhook: DeleteWebhookPayload;
  /** Disconnect the subscriber from the audience */
  disconnect: Success;
  /** Disconnect the subscriber from the audience */
  disconnectDep?: Maybe<Scalars['Boolean']['output']>;
  /** Export users as a csv and generates a download link */
  exportUsers: ExportUsersPayload;
  /** Find recurring service times with no future services and extend them. */
  extendServices: ExtendServicesPayload;
  /** Creates default Moment Templates for Organization */
  generateDefaultMomentTemplates: GenerateDefaultMomentTemplatesPayload;
  /** Generate a pdf document from markup */
  generatePdf: Scalars['String']['output'];
  /** Grants previously revoked write permissions to the public channel for the current service. */
  grantPublicWrite: Success;
  /** Invite new user with the given input */
  inviteUser: InviteUserPayload;
  /** Join a channel */
  joinChannel: Success;
  /** Leave a channel */
  leaveChannel: Success;
  /** Mute a subscriber preventing them from publishing messages on the public channel. */
  muteSubscriber: Success;
  /** Create or update a Subscriber. */
  newSaveSubscriber: NewSaveSubscriberPayload;
  /** Publish a moment */
  publishMoment: JobSuccess;
  /** Publish a service */
  publishService: Success;
  /** Publish all subcribers for an organization to pubsub. */
  publishSubscribersForOrganization: Success;
  /** Rebuild Moment Schedule */
  rebuildMomentSchedule: Success;
  /** Re-invite user with the given input */
  reinviteUser: ReinviteUserPayload;
  /** Delete content */
  removeContent: RemoveContentPayload;
  /** Delete content */
  removeContentDep: Success;
  /** Request reset password for provided email */
  requestPasswordReset: Success;
  /** Submit Offline Prayer Request. */
  requestPrayer?: Maybe<RequestPrayerPayload>;
  /** Request prayer */
  requestPrayerDep: Success;
  /** Reset password with provided input */
  resetPassword: Success;
  /** Revert a list of fields on the subscriber to their previous values */
  revertSubscriber: RevertSubscriberPayload;
  /** Revokes the write permissions to the public channel for the current service and deletes all messages. */
  revokePublicWrite: Success;
  /** Save content */
  saveContent: SaveContentPayload;
  /** Save content */
  saveContentDep: SaveContentResult;
  /** Save identity with provided input */
  saveIdentity: SaveIdentityPayload;
  saveIdentityDep: Success;
  /** Create or update an Integration. */
  saveIntegration: SaveIntegrationPayload;
  /** Saves a Moment Instance. */
  saveMomentInstance: SaveMomentInstancePayload;
  /** Saves a Moment Schedule. */
  saveMomentSchedule: SaveMomentSchedulePayload;
  /** Create or update a Moment Template. */
  saveMomentTemplate: SaveMomentTemplatePayload;
  /** Save an offline video */
  saveOfflineVideo: SaveOfflineVideoPayload;
  /** Creates or Updates Onboarding steps */
  saveOnboardingStep?: Maybe<SaveOnboardingStepPayload>;
  /** Create or update an Organization. */
  saveOrganization?: Maybe<SaveOrganizationPayload>;
  /** Saves a preview service */
  savePreviewService?: Maybe<SavePreviewServicePayload>;
  saveReportingConfig: SaveReportingConfigPayload;
  /** Save the role identifier with the given input */
  saveRoleIdentifier: SaveRoleIdentifierPayload;
  /** Save a service */
  saveService: SaveServicePayload;
  /** Save a service */
  saveServiceDep: Success;
  /** Update attributes associated with the provided subscriber */
  saveSubscriber: SaveSubscriberPayload;
  /** Update attributes associated with the provided subscriber */
  saveSubscriberDep: Success;
  /** Save a video */
  saveVideo: SaveVideoPayload;
  /** Create or update a Webhook. */
  saveWebhook: SaveWebhookPayload;
  /** Queue action count processing. */
  submitMessageAction: Success;
  /** Submits a Moment Action. */
  submitMomentAction: SubmitMomentActionPayload;
  /** Subscribe the subscriber to a channel */
  subscribe: Success;
  /** Subscribe the subscriber to a channel */
  subscribeDep?: Maybe<Scalars['Boolean']['output']>;
  /** Syncs all subscribers with Google Sheets. */
  syncGoogleSheetsIntegration: BackgroundResponse;
  /** Toggle automatic post of a moment. */
  toggleMomentScheduling: Success;
  /** Unmute a subscriber restoring their ability to publish messages on the public channel. */
  unmuteSubscriber: Success;
  /** Unsubscribe the subscriber from a channel */
  unsubscribe: Success;
  /** Unsubscribe the subscriber from a channel */
  unsubscribeDep?: Maybe<Scalars['Boolean']['output']>;
};

export type MutationAcceptInviteArgs = {
  input: AcceptInviteInput;
};

export type MutationAcceptInviteToChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAddLanguageToChannelArgs = {
  channel: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};

export type MutationAddLanguageToChannelDepArgs = {
  channel: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};

export type MutationAddLanguageToChannelsArgs = {
  channels: Array<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
};

export type MutationAddLanguageToChannelsDepArgs = {
  channels: Array<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationDeleteIdentitiesArgs = {
  subscriberId: Scalars['ID']['input'];
};

export type MutationDeleteIdentitiesDepArgs = {
  subscriberId: Scalars['ID']['input'];
};

export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMessageArgs = {
  input: MessageInput;
};

export type MutationDeleteMomentInstanceArgs = {
  input: DeleteMomentInstanceInput;
};

export type MutationDeleteMomentTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteServiceArgs = {
  applyTo: ApplyEnum;
  id: Scalars['ID']['input'];
};

export type MutationDeleteServiceDepArgs = {
  applyTo: ApplyEnum;
  id: Scalars['ID']['input'];
};

export type MutationDeleteSubscriberArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSubscriberDepArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVideoArgs = {
  contentId: Scalars['ID']['input'];
};

export type MutationDeleteWebhookArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisconnectArgs = {
  channelId: Scalars['ID']['input'];
  subscriberId: Scalars['ID']['input'];
};

export type MutationDisconnectDepArgs = {
  channelId: Scalars['ID']['input'];
  subscriberId: Scalars['ID']['input'];
};

export type MutationExportUsersArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationExtendServicesArgs = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationGenerateDefaultMomentTemplatesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationGeneratePdfArgs = {
  html: Scalars['String']['input'];
};

export type MutationGrantPublicWriteArgs = {
  subscriberId: Scalars['ID']['input'];
};

export type MutationInviteUserArgs = {
  input: InviteUserInput;
};

export type MutationJoinChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationLeaveChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMuteSubscriberArgs = {
  muteUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subscriberId: Scalars['ID']['input'];
};

export type MutationNewSaveSubscriberArgs = {
  input: SubscriberInput;
};

export type MutationPublishMomentArgs = {
  input: PublishMomentInput;
};

export type MutationPublishServiceArgs = {
  input: PublishServiceInput;
};

export type MutationPublishSubscribersForOrganizationArgs = {
  destinationType: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
  sheetId: Scalars['String']['input'];
  sidekiqBatchId: Scalars['String']['input'];
};

export type MutationRebuildMomentScheduleArgs = {
  services: Array<MomentServiceInput>;
};

export type MutationReinviteUserArgs = {
  input: ReinviteUserInput;
};

export type MutationRemoveContentArgs = {
  id: Scalars['ID']['input'];
  services: Array<ServiceInput>;
};

export type MutationRemoveContentDepArgs = {
  id: Scalars['ID']['input'];
  services: Array<ServiceInput>;
};

export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};

export type MutationRequestPrayerArgs = {
  input: RequestPrayerInput;
};

export type MutationRequestPrayerDepArgs = {
  input?: InputMaybe<RequestPrayerInput>;
};

export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type MutationRevertSubscriberArgs = {
  input: RevertSubscriberInput;
};

export type MutationRevokePublicWriteArgs = {
  subscriberId: Scalars['ID']['input'];
};

export type MutationSaveContentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ContentInput;
};

export type MutationSaveContentDepArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ContentInput;
};

export type MutationSaveIdentityArgs = {
  input: IdentityInput;
};

export type MutationSaveIdentityDepArgs = {
  input: IdentityInput;
};

export type MutationSaveIntegrationArgs = {
  input: IntegrationInput;
};

export type MutationSaveMomentInstanceArgs = {
  input: MomentInstanceInput;
};

export type MutationSaveMomentScheduleArgs = {
  contentId: Scalars['ID']['input'];
  input: Array<MomentScheduleItemInput>;
};

export type MutationSaveMomentTemplateArgs = {
  input: MomentTemplateInput;
};

export type MutationSaveOfflineVideoArgs = {
  input: OfflineVideoInput;
};

export type MutationSaveOnboardingStepArgs = {
  input: OnboardingStepInput;
};

export type MutationSaveOrganizationArgs = {
  input: OrganizationInput;
};

export type MutationSavePreviewServiceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSaveReportingConfigArgs = {
  input: ReportingConfigInput;
};

export type MutationSaveRoleIdentifierArgs = {
  input: RoleIdentifierInput;
};

export type MutationSaveServiceArgs = {
  applyTo: ApplyEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ServiceInput;
};

export type MutationSaveServiceDepArgs = {
  applyTo: ApplyEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ServiceInput;
};

export type MutationSaveSubscriberArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<SubscriberInput>;
};

export type MutationSaveSubscriberDepArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<SubscriberInput>;
};

export type MutationSaveVideoArgs = {
  input: VideoInput;
};

export type MutationSaveWebhookArgs = {
  input: WebhookInput;
};

export type MutationSubmitMessageActionArgs = {
  input: MessageActionInput;
};

export type MutationSubmitMomentActionArgs = {
  input: MomentActionInput;
};

export type MutationSubscribeArgs = {
  channelId: Scalars['ID']['input'];
  channelType?: InputMaybe<Scalars['String']['input']>;
  subscriberIds: Array<Scalars['ID']['input']>;
};

export type MutationSubscribeDepArgs = {
  channelId: Scalars['ID']['input'];
  channelType?: InputMaybe<Scalars['String']['input']>;
  subscriberIds: Array<Scalars['ID']['input']>;
};

export type MutationSyncGoogleSheetsIntegrationArgs = {
  destinationType: GoogleSheetsDestinationType;
  integrationId: Scalars['ID']['input'];
};

export type MutationToggleMomentSchedulingArgs = {
  enabled: Scalars['Boolean']['input'];
  serviceId: Scalars['ID']['input'];
};

export type MutationUnmuteSubscriberArgs = {
  subscriberId: Scalars['ID']['input'];
};

export type MutationUnsubscribeArgs = {
  channelId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

export type MutationUnsubscribeDepArgs = {
  channelId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

export enum NavigationLinkOption {
  /** Title Case */
  TITLE = 'TITLE',
  /** Upper Case */
  UPPER = 'UPPER',
}

/** Autogenerated return type of NewSaveSubscriber */
export type NewSaveSubscriberPayload = {
  __typename?: 'NewSaveSubscriberPayload';
  /** A list of errors that occured when saving the subscriber. */
  errors: Array<Error>;
  /** The saved Subscriber. */
  subscriber?: Maybe<Subscriber>;
};

/** Represents a Next Steps Moment. */
export type NextStepsMoment = {
  __typename?: 'NextStepsMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the next steps moment. */
  options: NextStepsMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of a next steps moment. */
export type NextStepsMomentInstance = MomentInstance & {
  __typename?: 'NextStepsMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type NextStepsMomentOptions = {
  __typename?: 'NextStepsMomentOptions';
  /** The text for the button in the next steps moment. */
  buttonText: Scalars['String']['output'];
  /** A description for the next steps moment. */
  description: Scalars['String']['output'];
  /** Optional icon URL for the next steps moment. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** Optional lead-in text for the next steps moment. */
  leadInText?: Maybe<Scalars['String']['output']>;
  /** The copy text for the next steps moment. */
  text: Scalars['String']['output'];
  /** The URL for the next steps moment. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Flag values defining how to handle event loading */
export enum NullEventLoadMethod {
  /** Load the next event occurance. */
  LOAD_NEXT = 'LOAD_NEXT',
  /** Load the previous event occurance. */
  LOAD_PREVIOUS = 'LOAD_PREVIOUS',
}

/** Represents offline content */
export type OfflineContent = {
  /** The content source */
  source?: Maybe<Scalars['String']['output']>;
  /** The offline content type */
  type: OfflineContentType;
  /** The content url */
  url?: Maybe<Scalars['String']['output']>;
};

/** Attributes for updating offline content. */
export type OfflineContentInput = {
  /** The offline content video options */
  options?: InputMaybe<VideoOptionsInput>;
  /** The content source */
  source: Scalars['String']['input'];
  /** The offline content type */
  type: OfflineContentType;
};

export enum OfflineContentType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

/** Represents an Offline Image */
export type OfflineImage = OfflineContent & {
  __typename?: 'OfflineImage';
  /** The content source */
  source?: Maybe<Scalars['String']['output']>;
  /** The offline content type */
  type: OfflineContentType;
  /** The content url */
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents an Offline Image */
export type OfflineVideo = OfflineContent & {
  __typename?: 'OfflineVideo';
  /** The offline video options. */
  options: VideoOptions;
  /** The content source */
  source?: Maybe<Scalars['String']['output']>;
  /** The offline content type */
  type: OfflineContentType;
  /** The content url */
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents input for an offline video. */
export type OfflineVideoInput = {
  /** The ID of the video. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The video options. */
  options?: InputMaybe<VideoOptionsInput>;
  /** The organization ID to save for. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The source of the video. */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the onboarding steps of an organization */
export type OnboardingStep = {
  __typename?: 'OnboardingStep';
  /** The indicator that marks the completion status of the onboarding step */
  completed: Scalars['Boolean']['output'];
  /** The id of the onboarding step */
  id: Scalars['ID']['output'];
  /** The key for the onboarding step */
  key: Scalars['String']['output'];
  /** The ordinal of the onboarding step */
  ordinal: Scalars['Int']['output'];
  /** The indicator that marks whether the onboarding step has been skipped or not */
  skipped: Scalars['Boolean']['output'];
};

/** Attributes for creating or updating Onboarding Steps */
export type OnboardingStepInput = {
  /** The completion status of the onboarding step */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier for the onboarding step */
  id: Scalars['ID']['input'];
  /** The indication of whether an onboarding step has been skipped or not */
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an Open ID Connect Integration. */
export type OpenIdConnect = Integration & {
  __typename?: 'OpenIdConnect';
  /** The config for an Open ID Connect Integration. */
  config: OpenIdConnectConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OpenIdConnectConfig = {
  __typename?: 'OpenIdConnectConfig';
  /** The Client ID for Open ID Connect */
  clientId: Scalars['String']['output'];
  /** The Client Secret for Open ID Connect */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** The Issuer URI for Open ID Connect */
  issuerUri: Scalars['String']['output'];
};

export enum OrderDirection {
  /** Ascending order */
  ASC = 'ASC',
  /** Descending order */
  DESC = 'DESC',
}

/** Directional enums */
export enum OrderType {
  /** Ascending order */
  ASC = 'ASC',
  /** Descending order */
  DESC = 'DESC',
}

/** Represents an Organization. */
export type Organization = {
  __typename?: 'Organization';
  /** The address of the organization. */
  address: Scalars['String']['output'];
  /** The address two of the organization. */
  addressTwo?: Maybe<Scalars['String']['output']>;
  /** Get Metrics Overview for Organization */
  analyticsOverview: AnalyticsOverviewMetrics;
  /** The appearance of the Organization */
  appearance: Appearance;
  /** The city of the organization. */
  city: Scalars['String']['output'];
  /** Return paginated list of contents */
  contents: ContentConnection;
  /** The country of the organization. */
  country: Scalars['String']['output'];
  /** When the organization was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custom domain name for the organization, e.g. live.foo.church. */
  customDomain?: Maybe<Scalars['String']['output']>;
  /** Email consent of the Organization. */
  emailConsent?: Maybe<EmailConsentType>;
  /** The id of the organization. */
  id: Scalars['ID']['output'];
  integrations: Array<Integration>;
  /** The links to show the user for the Organization */
  links: Array<OrganizationLink>;
  /** The login banner of the organization. */
  loginBanner: LoginBanner;
  /** The Moment Templates for the provided organization. */
  momentTemplates: Array<MomentTemplate>;
  /** The name of the organization. */
  name: Scalars['String']['output'];
  /** The Next Steps Moment Templates for the provided organization. */
  nextStepsTemplates: Array<MomentTemplate>;
  /** The offline content */
  offlineContent?: Maybe<OfflineContent>;
  /** The offline prayer recipients */
  offlinePrayerRecipients: Array<Scalars['String']['output']>;
  offlineVideo?: Maybe<Video>;
  /** The offline video URL */
  offlineVideoUrl?: Maybe<Scalars['String']['output']>;
  /** The list of onboarding steps for an organization */
  onboardingSteps?: Maybe<Array<OnboardingStep>>;
  /** THe platform URL of the organization. */
  platformUrl: Scalars['String']['output'];
  /** Privacy url for the Organization */
  privacyUrl?: Maybe<Scalars['String']['output']>;
  /** Return a list of recently used content */
  recentContent: Array<RecentContent>;
  reportingConfig?: Maybe<ReportingConfig>;
  /** Returns list of role identifiers for the organization */
  roleIdentifiers: Array<RoleIdentifier>;
  /** Returns list of roles for the organization */
  roles: Array<Role>;
  /** Returns the organization's services for the time period specified. */
  servicesConnection: ServicesConnection;
  /** The share description for the organization. */
  shareDescription?: Maybe<Scalars['String']['output']>;
  /** The share image for the organization. */
  shareImage?: Maybe<Scalars['String']['output']>;
  /** The slug of the organization. */
  slug: Scalars['String']['output'];
  /** The slug domain of the organization. */
  slugDomain: Scalars['String']['output'];
  /** The state of the organization. */
  state: Scalars['String']['output'];
  /** The organization's approval status */
  status: OrganizationStatus;
  /** The last time the organization's status was changed */
  statusChangedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subscribers: SubscriberConnection;
  /** Returns the organization's subscribers. */
  subscribersConnectionDep: SubscribersConnection;
  /** Terms url for the Organization */
  termsUrl?: Maybe<Scalars['String']['output']>;
  /** The IANA timezone of the organization. */
  timezone: Scalars['String']['output'];
  transcripts: Array<Transcript>;
  /** The version history for the organization. */
  versions: Array<OrganizationVersion>;
  webhookEvents: WebhookEventConnection;
  /** The website of the organization. */
  website?: Maybe<Scalars['String']['output']>;
  /** The welcome banner of the organization. */
  welcomeBanner: WelcomeBanner;
  /** The zip code of the organization. */
  zip: Scalars['String']['output'];
};

/** Represents an Organization. */
export type OrganizationAnalyticsOverviewArgs = {
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};

/** Represents an Organization. */
export type OrganizationContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Organization. */
export type OrganizationIntegrationsArgs = {
  filter?: InputMaybe<IntegrationSearchFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents an Organization. */
export type OrganizationRecentContentArgs = {
  before?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Organization. */
export type OrganizationServicesConnectionArgs = {
  expandToContentId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ServicesConnectionFilter>;
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderType>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};

/** Represents an Organization. */
export type OrganizationSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubscribersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubscriberSortOrder>>;
};

/** Represents an Organization. */
export type OrganizationSubscribersConnectionDepArgs = {
  exclude?: InputMaybe<Array<SubscriberType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an Organization. */
export type OrganizationWebhookEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WebhookEventsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationAggregate = {
  __typename?: 'OrganizationAggregate';
  count: Scalars['Int']['output'];
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total results count */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

export type OrganizationFilter = {
  /** Include deactivated organizations. */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The search string. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating or updating an Organization. */
export type OrganizationInput = {
  /** The address of the Organization */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The address two of the Organization */
  addressTwo?: InputMaybe<Scalars['String']['input']>;
  /** The appearance of the Organization */
  appearance?: InputMaybe<AppearanceInput>;
  /** The city of the Organization */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country of the Organization */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The custom domain name for the organization, e.g. live.foo.church. */
  customDomain?: InputMaybe<Scalars['String']['input']>;
  /** Email consent of the Organization. */
  emailConsent?: InputMaybe<EmailConsentType>;
  /** The unique id of the organization. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The links of the Organization */
  links?: InputMaybe<Array<LinkInput>>;
  /** The login banner of the Organization */
  loginBanner?: InputMaybe<LoginBannerInput>;
  /** The name of the Organization */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The offline content */
  offlineContent?: InputMaybe<OfflineContentInput>;
  /** The offline prayer recipients */
  offlinePrayerRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The offline video URL */
  offlineVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Privacy url for the Organization */
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  /** The share description for the organization. */
  shareDescription?: InputMaybe<Scalars['String']['input']>;
  /** The share image for the organization. */
  shareImage?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not it is a new Organization. */
  signup?: InputMaybe<Scalars['Boolean']['input']>;
  /** The slug of the Organization */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the slug is claimed. */
  slugClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The state of the Organization */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Set the status of the Organization. */
  status?: InputMaybe<OrganizationStatus>;
  /** Terms url for the Organization */
  termsUrl?: InputMaybe<Scalars['String']['input']>;
  /** The IANA timezone of the Organization */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** The website of the Organization */
  website?: InputMaybe<Scalars['String']['input']>;
  /** The welcome banner of the Organization */
  welcomeBanner?: InputMaybe<WelcomeBannerInput>;
  /** The zip of the Organization */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a navigation link for an organization */
export type OrganizationLink = {
  __typename?: 'OrganizationLink';
  /**
   * The URI to send the user to
   * @deprecated Utilize the URL field instead.
   */
  href: Scalars['String']['output'];
  /** The id of the link */
  id: Scalars['ID']['output'];
  /** The unique ID for the link */
  key: Scalars['String']['output'];
  /** The Label for the link */
  label: Scalars['String']['output'];
  /** The order of the link */
  order: Scalars['Int']['output'];
  /** The URI to send the user to */
  url: Scalars['String']['output'];
};

export enum OrganizationStatus {
  APPROVED = 'APPROVED',
  DEACTIVATED = 'DEACTIVATED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

/** Represents a version/audit record for tracking changes to an organization. */
export type OrganizationVersion = {
  __typename?: 'OrganizationVersion';
  /** The changes made in this version (before/after for each changed attribute). */
  changes?: Maybe<Scalars['JSON']['output']>;
  /** When this version was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The type of event (create, update, destroy). */
  event: Scalars['String']['output'];
  /** The unique identifier of the version. */
  id: Scalars['ID']['output'];
  /** The type of record this version belongs to. */
  itemType: OrganizationVersionItemType;
  /** The subscriber who made this change. */
  subscriber?: Maybe<Subscriber>;
  /** The subscriber ID if whodunnit is a valid UUID, otherwise nil. */
  subscriberId?: Maybe<Scalars['ID']['output']>;
  /** The raw identifier of who made this change (subscriber ID, worker name, or nil). */
  whodunnit?: Maybe<Scalars['String']['output']>;
};

/** The type of record an organization version belongs to */
export enum OrganizationVersionItemType {
  /** Organization record */
  ORGANIZATION = 'ORGANIZATION',
}

export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  aggregate: OrganizationAggregate;
  organizations: Array<Organization>;
};

/** Represents an Osano Integration. */
export type Osano = Integration & {
  __typename?: 'Osano';
  /** The config for an Osano Integration. */
  config: OsanoConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OsanoConfig = {
  __typename?: 'OsanoConfig';
  /** The Account ID for the Osano integration. */
  accountId: Scalars['String']['output'];
  /** The Config ID for the Osano integration. */
  configId: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Represents a permission and its key */
export type Permission = {
  __typename?: 'Permission';
  /** The format for a permission key is service.item.action */
  key: Scalars['String']['output'];
};

export type PersonalChannel = Channel & {
  __typename?: 'PersonalChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  /** Type of Channel. */
  type: ChannelType;
};

export type PrayerChannel = Channel & {
  __typename?: 'PrayerChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  subscribers: SubscriberConnection;
  /**
   * Load all subscribers in a given channel (DEPRECATED)
   * @deprecated Removing in favor of channel { subscribers } using connection type
   */
  subscribersDep: Array<Subscriber>;
  /** Type of Channel. */
  type: ChannelType;
};

export type PrayerChannelSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubscribersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Prayer Moment. */
export type PrayerMoment = {
  __typename?: 'PrayerMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the prayer moment. */
  options: PrayerMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of an prayer moment. */
export type PrayerMomentInstance = MomentInstance & {
  __typename?: 'PrayerMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type PrayerMomentOptions = {
  __typename?: 'PrayerMomentOptions';
  /** The button copy text. */
  buttonText: Scalars['String']['output'];
  /** The copy text. */
  text: Scalars['String']['output'];
};

/** An offline prayer request object. */
export type PrayerRequest = {
  __typename?: 'PrayerRequest';
  /** The requester email */
  email: Scalars['String']['output'];
  /** The ID of the prayer request */
  id: Scalars['ID']['output'];
  /** The requester message */
  message: Scalars['String']['output'];
  /** The requester name */
  name: Scalars['String']['output'];
};

export type PreviewServiceJob = JobInterface & {
  __typename?: 'PreviewServiceJob';
  at?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<PreviewServiceJobMeta>;
  percentComplete?: Maybe<Scalars['Int']['output']>;
  status: JobStatus;
  total?: Maybe<Scalars['Int']['output']>;
  updateTime: Scalars['ISO8601DateTime']['output'];
};

export type PreviewServiceJobMeta = {
  __typename?: 'PreviewServiceJobMeta';
  serviceId?: Maybe<Scalars['ID']['output']>;
};

/** Represents a Private Channel Invite. */
export type PrivateChannelInvite = {
  __typename?: 'PrivateChannelInvite';
  /** The timestamp of the accept. */
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The subscriber id of the accepter. */
  accepterSubscriberId?: Maybe<Scalars['ID']['output']>;
  /** The channel of the invite. */
  channel: Channel;
  /** The id of the invite. */
  id: Scalars['ID']['output'];
  /** If the invite is open. */
  pending: Scalars['Boolean']['output'];
  /** The timestamp of the request. */
  requestedAt: Scalars['ISO8601DateTime']['output'];
  /** The subscriber id of the requester. */
  requesterSubscriberId: Scalars['ID']['output'];
};

/** Represents a subscription in the system */
export type ProfileSubscription = {
  __typename?: 'ProfileSubscription';
  /** The id of the channel */
  channelId: Scalars['String']['output'];
  /** The id of the subscriber */
  subscriberId: Scalars['ID']['output'];
};

export type PublicChannel = Channel & {
  __typename?: 'PublicChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  subscribers: SubscriberConnection;
  /** Type of Channel. */
  type: ChannelType;
};

export type PublicChannelSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubscribersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input Type for Moments. */
export type PublishMomentInput = {
  /** If Moment was cancelled. */
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The channel that the moment is associated to */
  channelId: Scalars['ID']['input'];
  /** Count */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Boolean field showing if moment instance has been deleted. */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boolean field showing if moment instance has been delivered. */
  delivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** The channel that the moment should publish to */
  destinationChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** The id for the moment, must be a UUID. */
  id: Scalars['ID']['input'];
  /** Number of likes */
  likes?: InputMaybe<Scalars['Int']['input']>;
  /** Moment Template */
  momentTemplate: PublishMomentTemplateInput;
  /** The organization that the moment is associated to */
  organizationId: Scalars['ID']['input'];
  /** The post time of the moment instance. */
  postTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Boolean field showing if moment instance has been posted. */
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  /** When the moment was posted */
  postedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The service that the moment is associated to. */
  serviceId: Scalars['ID']['input'];
  /** Number of shares */
  shares?: InputMaybe<Scalars['Int']['input']>;
  /** What triggered the moment post. */
  trigger?: InputMaybe<Scalars['String']['input']>;
};

/** Input Type for Moments. */
export type PublishMomentTemplateInput = {
  /** The id for the moment template, must be a UUID. */
  id: Scalars['ID']['input'];
  /** Options */
  options: Scalars['JSON']['input'];
  /** Moment Type */
  type: MomentType;
};

/** Input Type for Services. */
export type PublishServiceInput = {
  /** The id for the Service, must be a UUID. */
  id: Scalars['ID']['input'];
  /** If moment scheduling is enabled. */
  momentSchedulingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PubnubKeys = {
  __typename?: 'PubnubKeys';
  /** The ID or token for the pubnub channel. */
  publishKey: Scalars['String']['output'];
  /** The name of the channel */
  subscribeKey: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Returns the default Area of Ministries */
  areaOfMinistries: Array<AreaOfMinistry>;
  /** Returns true if the current subscriber can request prayer. */
  canRequestPrayer: Scalars['Boolean']['output'];
  /** Returns the channel with the given ID. */
  channel?: Maybe<Channel>;
  /** Returns channel stats for a subscriber */
  channelStatsForSubscribers: Array<SubscriberChannelStats>;
  /**
   * Returns the current channels for the service and authorized user.
   * @deprecated Deprecating in favor of federation { service { feed } }
   */
  channelsForService?: Maybe<Array<Channel>>;
  /** Returns the organization scoped to the request domain. */
  currentOrganization?: Maybe<Organization>;
  /** Returns the current service running. */
  currentService: Service;
  /** Load profile data for current subscriber from access_token */
  currentSubscriber?: Maybe<Subscriber>;
  /** Returns the status of a job */
  eventJob?: Maybe<JobInterface>;
  /** Get the status of the job with matching ID. */
  integrationJobStatus?: Maybe<JobStatus>;
  integrationsForOrganization: Array<Integration>;
  /** Returns the job status */
  jobStatus?: Maybe<Scalars['String']['output']>;
  /** Returns default links. */
  links: Array<Link>;
  /** A query to load attributes about an identity. */
  loadIdentity?: Maybe<IdentityResponse>;
  /** Loads an integration by ID. */
  loadIntegration?: Maybe<Integration>;
  /** Returns the video embed for the last service if it exists. */
  loadLastVideoEmbed?: Maybe<Scalars['String']['output']>;
  /** Load the organization with the given id */
  loadOrganization?: Maybe<Organization>;
  /** Load the role with the given id */
  loadRole?: Maybe<Role>;
  /** Returns the service with the given id. */
  loadService?: Maybe<Service>;
  /** Loads a webhook by ID. */
  loadWebhook?: Maybe<Webhook>;
  /** Get Analytics Metrics Overview for a time period */
  metricsForAnalyticsOverview: AnalyticsOverviewMetrics;
  /**
   * Get Metrics for Moment Instances
   * @deprecated Deprecating in favor of federated access { momentInstance { metrics } }
   */
  metricsForMomentInstances?: Maybe<Array<MomentInstanceMetric>>;
  /**
   * Get Metrics for Services
   * @deprecated Deprecating in favor of federated access { service { metrics } }
   */
  metricsForServices?: Maybe<Array<ServiceMetric>>;
  /** Get moment instance by ID. */
  momentInstance: MomentInstance;
  /**
   * The Moment Instances for the provided service.
   * @deprecated use "service { momentInstances }" instead
   */
  momentInstancesForService: Array<MomentInstance>;
  /**
   * The scheduled moments for the provided content.
   * @deprecated use "content { momentScheduleItems }" instead
   */
  momentScheduleItemsForContent: Array<MomentScheduleItem>;
  /** Finds a Moment Template by ID. */
  momentTemplate?: Maybe<MomentTemplate>;
  /**
   * The Moment Templates for the provided organization.
   * @deprecated use "organization { momentTemplates }" instead
   */
  momentTemplatesForOrganization: Array<MomentTemplate>;
  organizations: OrganizationConnection;
  /** Returns organizations */
  organizationsConnection: OrganizationsConnection;
  /** Returns the Pubnub publish and subscribe keys for the current environment. */
  pubnubKeys: PubnubKeys;
  /** @deprecated Removing in favor of Graphql Federation use { organization { reportingConfig } } */
  reportingConfigForOrganization?: Maybe<ReportingConfig>;
  requestChannel?: Maybe<Channel>;
  /** Returns an invite to the channel. */
  requestInviteToChannel?: Maybe<PrivateChannelInvite>;
  /**
   * Returns list of role identifiers for the organization
   * @deprecated Removing in favor of Graphql Federation use { organization { roleIdentifiers } }
   */
  roleIdentifiersForOrganization: Array<RoleIdentifier>;
  /**
   * Returns list of roles for the organization
   * @deprecated Removing in favor of Graphql Federation use { organization { roles } }
   */
  rolesForOrganization: Array<Role>;
  /** Returns the service at the specified time. */
  serviceAt: Service;
  /**
   * Returns the organization's services for the time period specified.
   * @deprecated Removing in favor of Graphql Federation use { organization { servicesConnection } }
   */
  servicesConnection: ServicesConnection;
  /** Returns all services the content is attached to */
  servicesForContent: Array<Service>;
  /** Load subscriber for the given subscriber id */
  subscriber?: Maybe<Subscriber>;
  subscribers: SubscriberConnection;
  /** Returns the organization's subscribers. */
  subscribersConnectionDep: SubscribersConnection;
  /** Load all subscribers in a given channel (DEPRECATED) */
  subscribersForChannelDep: Array<Subscriber>;
  /** @deprecated Removing in favor of Graphql Federation use { organization { transcripts } } */
  transcriptsForOrganization: Array<Transcript>;
  translateTextForChannel: Array<Translation>;
  /**
   * The video for the content ID. If the videoStarted is false returns null.
   * @deprecated Removing in favor of Graphql Federation use { content { video } }
   */
  videoForContent?: Maybe<Video>;
  /**
   * The offline video for the organization.
   * @deprecated Removing in favor of Graphql Federation use { organization { video } }
   */
  videoForOfflineContent?: Maybe<Video>;
  webhookEventsForOrganization: WebhookEventConnection;
};

export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChannelStatsForSubscribersArgs = {
  subscriberIds: Array<Scalars['ID']['input']>;
};

export type QueryChannelsForServiceArgs = {
  feedStarted: Scalars['Boolean']['input'];
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCurrentServiceArgs = {
  onEmpty?: InputMaybe<NullEventLoadMethod>;
};

export type QueryEventJobArgs = {
  jobId: Scalars['ID']['input'];
};

export type QueryIntegrationJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};

export type QueryIntegrationsForOrganizationArgs = {
  filter?: InputMaybe<IntegrationSearchFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryJobStatusArgs = {
  jobId: Scalars['String']['input'];
};

export type QueryLoadIdentityArgs = {
  subscriberId: Scalars['ID']['input'];
  type: IdentityType;
};

export type QueryLoadIntegrationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLoadOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLoadRoleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLoadServiceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLoadWebhookArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMetricsForAnalyticsOverviewArgs = {
  input: MetricsForAnalyticsOverviewInput;
};

export type QueryMetricsForMomentInstancesArgs = {
  input: MetricsForMomentInstancesInput;
};

export type QueryMetricsForServicesArgs = {
  input: MetricsForServicesInput;
};

export type QueryMomentInstanceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMomentInstancesForServiceArgs = {
  serviceId: Scalars['ID']['input'];
};

export type QueryMomentScheduleItemsForContentArgs = {
  contentId: Scalars['ID']['input'];
};

export type QueryMomentTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMomentTemplatesForOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOrganizationsConnectionArgs = {
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportingConfigForOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryRequestChannelArgs = {
  format?: InputMaybe<ChannelKeyFormat>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ChannelInput;
  with?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryRequestInviteToChannelArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRoleIdentifiersForOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRolesForOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryServiceAtArgs = {
  time: Scalars['Timestamp']['input'];
};

export type QueryServicesConnectionArgs = {
  expandToContentId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ServicesConnectionFilter>;
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderType>;
  organizationId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type QueryServicesForContentArgs = {
  contentId: Scalars['ID']['input'];
};

export type QuerySubscriberArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubscribersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubscriberSortOrder>>;
};

export type QuerySubscribersConnectionDepArgs = {
  exclude?: InputMaybe<Array<SubscriberType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySubscribersForChannelDepArgs = {
  channelToken: Scalars['String']['input'];
};

export type QueryTranscriptsForOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryTranslateTextForChannelArgs = {
  channel: Scalars['String']['input'];
  sourceLanguageCode: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type QueryVideoForContentArgs = {
  contentId: Scalars['ID']['input'];
  videoStarted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryWebhookEventsForOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WebhookEventsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents a Quote Moment. */
export type QuoteMoment = {
  __typename?: 'QuoteMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the quote moment. */
  options: QuoteMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of a quote moment. */
export type QuoteMomentInstance = MomentInstance & {
  __typename?: 'QuoteMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** The number of times the moment was liked. */
  likes: Scalars['Int']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The number of times the moment was shared. */
  shares: Scalars['Int']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type QuoteMomentOptions = {
  __typename?: 'QuoteMomentOptions';
  /** The attribution for the quote. */
  attribution?: Maybe<Scalars['String']['output']>;
  /** The text of the quote. */
  text: Scalars['String']['output'];
};

export type ReactionChannel = Channel & {
  __typename?: 'ReactionChannel';
  /** Is this a direct, user to user, channel. */
  direct: Scalars['Boolean']['output'];
  /** Is this a group channel. */
  group: Scalars['Boolean']['output'];
  /** The token for the pubnub channel. */
  id: Scalars['ID']['output'];
  /** The key for the channel. */
  key: Scalars['String']['output'];
  /** The name of the channel */
  name: Scalars['String']['output'];
  /** Type of Channel. */
  type: ChannelType;
};

/** An aggregate for recently used content */
export type RecentContent = {
  __typename?: 'RecentContent';
  /** Content of a service */
  content: Content;
  /** The last service that used the related content */
  lastService: Service;
  /** The number of services that have used this content */
  serviceCount: Scalars['Int']['output'];
};

/** The frequency of a service */
export enum RecurrenceEnum {
  /** recurs daily */
  DAILY = 'DAILY',
  /** recurs monthly */
  MONTHLY = 'MONTHLY',
  /** has no recurrence */
  ONCE = 'ONCE',
  /** recurs weekly */
  WEEKLY = 'WEEKLY',
  /** recurs yearly */
  YEARLY = 'YEARLY',
}

/** Attributes for re-inviting a user. */
export type ReinviteUserInput = {
  /** The id of the subscriber */
  subscriberId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReinviteUser */
export type ReinviteUserPayload = {
  __typename?: 'ReinviteUserPayload';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The saved subscriber. */
  subscriber?: Maybe<Subscriber>;
};

/** Autogenerated return type of RemoveContent */
export type RemoveContentPayload = {
  __typename?: 'RemoveContentPayload';
  content?: Maybe<Content>;
  errors: Array<Error>;
};

export type ReportingConfig = {
  __typename?: 'ReportingConfig';
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  serviceReportRecipients?: Maybe<Array<Scalars['String']['output']>>;
  transcriptsEnabled: Scalars['Boolean']['output'];
};

export type ReportingConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  serviceReportRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  transcriptsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attributes for requesting prayer. */
export type RequestPrayerInput = {
  /** The requester email */
  email: Scalars['String']['input'];
  /** The ID of the prayer request */
  id: Scalars['ID']['input'];
  /** The requester message */
  message: Scalars['String']['input'];
  /** The requester name */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of RequestPrayer */
export type RequestPrayerPayload = {
  __typename?: 'RequestPrayerPayload';
  /** A list of errors that occured when submitting the prayer request. */
  errors: Array<Error>;
  /** The prayer request created. */
  prayerRequest?: Maybe<PrayerRequest>;
};

/** Represents a Response Moment. */
export type ResponseMoment = {
  __typename?: 'ResponseMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the response moment. */
  options: ResponseMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents an instance of a response moment. */
export type ResponseMomentInstance = MomentInstance & {
  __typename?: 'ResponseMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** The number of times this occurred */
  count: Scalars['Int']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ResponseMomentOptions = {
  __typename?: 'ResponseMomentOptions';
  /** The button text for the response moment. */
  buttonText: Scalars['String']['output'];
  /** The symbol for the response moment. */
  symbol: Symbol;
  /** The text of the response moment. */
  text: Scalars['String']['output'];
};

/** Input for reverting subscriber fields back to their previous values. */
export type RevertSubscriberInput = {
  /** A list of subscriber fields to revert */
  fields: Array<SubscriberFieldType>;
};

/** Autogenerated return type of RevertSubscriber */
export type RevertSubscriberPayload = {
  __typename?: 'RevertSubscriberPayload';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The modified subscriber. */
  subscriber?: Maybe<Subscriber>;
};

/** Represents a role and its permissions */
export type Role = {
  __typename?: 'Role';
  /** The id of the role */
  id: Scalars['ID']['output'];
  /** The label of the role */
  label: Scalars['String']['output'];
  /** The name of the role */
  name: Scalars['String']['output'];
  /** The permissions the role gives access to */
  permissions: Array<Permission>;
  /** The type of role. */
  type: RoleType;
};

/** Represents a role identifier */
export type RoleIdentifier = {
  __typename?: 'RoleIdentifier';
  /** Whether or not the role identifier is default. */
  default: Scalars['Boolean']['output'];
  /** The id of the role identifier */
  id: Scalars['ID']['output'];
  /** The key of the role identifier */
  key: Scalars['String']['output'];
  /** The label of the role identifier */
  label?: Maybe<Scalars['String']['output']>;
  /** The organization id of the role identifier */
  organizationId: Scalars['ID']['output'];
  /** The type of role identifier. */
  type: RoleIdentifierType;
};

/** Attributes for creating or updating a role identifier. */
export type RoleIdentifierInput = {
  /** The id of the role identifier */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The key for the role identifier. */
  key: Scalars['String']['input'];
  /** The label for the role identifier. */
  label: Scalars['String']['input'];
  /** The type of role identifier. */
  type: RoleIdentifierType;
};

export enum RoleIdentifierType {
  SYMBOL = 'SYMBOL',
  TEXT = 'TEXT',
}

export enum RoleType {
  /** Subscriber with admin role. */
  ADMIN = 'ADMIN',
  /** Subscriber with global role. */
  GLOBAL = 'GLOBAL',
  /** Subscriber with host role. */
  HOST = 'HOST',
  /** Subscriber with owner role. */
  OWNER = 'OWNER',
  SERVICE = 'SERVICE',
}

/** Represents a Salvation Moment. */
export type SalvationMoment = {
  __typename?: 'SalvationMoment';
  /** The id of the moment template. */
  id: Scalars['ID']['output'];
  /** If this moment is included in future services. */
  includedInFutureServices: Scalars['Boolean']['output'];
  /** The options of the salvation moment. */
  options: SalvationMomentOptions;
  /** The organization the moment template belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the moment template. */
  type: MomentType;
  /** The last updated timestamp. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum SalvationMomentFollowUpType {
  NONE = 'NONE',
  REQUEST_PRAYER = 'REQUEST_PRAYER',
  URL_MODAL = 'URL_MODAL',
  URL_NEW_TAB = 'URL_NEW_TAB',
}

/** Represents an instance of a salvation moment. */
export type SalvationMomentInstance = MomentInstance & {
  __typename?: 'SalvationMomentInstance';
  /** The moment template options */
  _rawTemplateOptions: Scalars['JSON']['output'];
  /**
   * Whether or not a scheduled moment instance was delivered but display was canceled.
   * @deprecated Deprecated in favor of deleted field.
   */
  canceled: Scalars['Boolean']['output'];
  /** The number of times this occured */
  count: Scalars['Int']['output'];
  /** Boolean field showing if moment instance has been deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Boolean field showing if moment instance has been delivered. */
  delivered: Scalars['Boolean']['output'];
  /** The ID of the Destination Channel. */
  destinationChannelId?: Maybe<Scalars['ID']['output']>;
  /** The id of the moment instance. */
  id: Scalars['ID']['output'];
  /** Get Metrics for Moment Instances */
  metrics: Array<MomentInstanceMetric>;
  /** The moment template of the moment instance. */
  momentTemplate: MomentTemplate;
  /** The organization the moment instance belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The post time of the moment instance. */
  postTime: Scalars['ISO8601DateTime']['output'];
  /** Boolean field showing if moment instance has been posted. */
  posted: Scalars['Boolean']['output'];
  /**
   * The posted time of the moment instance.
   * @deprecated Deprecated in favor of post_time field.
   */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization the moment template belongs to. */
  serviceId: Scalars['ID']['output'];
  /** The trigger source of the moment instance. */
  trigger: MomentTriggerType;
  /** Moment instance type */
  type?: Maybe<Scalars['String']['output']>;
};

export type SalvationMomentLabels = {
  __typename?: 'SalvationMomentLabels';
  /** The button text */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** The celebration message */
  celebrationMessage?: Maybe<Scalars['String']['output']>;
  /** The prompt label */
  prompt?: Maybe<Scalars['String']['output']>;
  /** The response label */
  response?: Maybe<Scalars['String']['output']>;
};

export type SalvationMomentOptions = {
  __typename?: 'SalvationMomentOptions';
  /** The custom labels assigned to the moment. */
  labels?: Maybe<SalvationMomentLabels>;
  /** Method of followup for the salvation. */
  salvationMomentFollowUpType: SalvationMomentFollowUpType;
  /** The URL for the method of followup. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of SaveContent */
export type SaveContentPayload = {
  __typename?: 'SaveContentPayload';
  content?: Maybe<Content>;
  errors: Array<Error>;
};

/** Represents a success type for SaveContent. */
export type SaveContentResult = {
  __typename?: 'SaveContentResult';
  errors: Array<Error>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SaveIdentity */
export type SaveIdentityPayload = {
  __typename?: 'SaveIdentityPayload';
  errors: Array<Error>;
  identity?: Maybe<IdentityResponse>;
};

/** Autogenerated return type of SaveIntegration */
export type SaveIntegrationPayload = {
  __typename?: 'SaveIntegrationPayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The saved Integration. */
  integration?: Maybe<Integration>;
};

/** Autogenerated return type of SaveMomentInstance */
export type SaveMomentInstancePayload = {
  __typename?: 'SaveMomentInstancePayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The Moment instance. */
  momentInstance?: Maybe<MomentInstance>;
};

/** Autogenerated return type of SaveMomentSchedule */
export type SaveMomentSchedulePayload = {
  __typename?: 'SaveMomentSchedulePayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The Moment schedule. */
  momentSchedule?: Maybe<Array<MomentScheduleItem>>;
};

/** Autogenerated return type of SaveMomentTemplate */
export type SaveMomentTemplatePayload = {
  __typename?: 'SaveMomentTemplatePayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The saved Moment Template. */
  momentTemplate?: Maybe<MomentTemplate>;
};

/** Autogenerated return type of SaveOfflineVideo */
export type SaveOfflineVideoPayload = {
  __typename?: 'SaveOfflineVideoPayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The saved Video. */
  video?: Maybe<Video>;
};

/** Autogenerated return type of SaveOnboardingStep */
export type SaveOnboardingStepPayload = {
  __typename?: 'SaveOnboardingStepPayload';
  /** A list of errors that occured when saving the onboarding step */
  errors: Array<Error>;
  /** The saved Onboarding Step */
  onboardingStep?: Maybe<OnboardingStep>;
};

/** Autogenerated return type of SaveOrganization */
export type SaveOrganizationPayload = {
  __typename?: 'SaveOrganizationPayload';
  /** A list of errors that occured when saving the organization. */
  errors: Array<Error>;
  /** The saved Organization. */
  organization?: Maybe<Organization>;
};

/** Autogenerated return type of SavePreviewService */
export type SavePreviewServicePayload = {
  __typename?: 'SavePreviewServicePayload';
  errors: Array<Error>;
  job?: Maybe<PreviewServiceJob>;
};

export type SaveReportingConfigPayload = {
  __typename?: 'SaveReportingConfigPayload';
  errors: Array<Maybe<Error>>;
  reportingConfig: ReportingConfig;
};

/** Autogenerated return type of SaveRoleIdentifier */
export type SaveRoleIdentifierPayload = {
  __typename?: 'SaveRoleIdentifierPayload';
  /** A list of errors that occured when saving the subscriber. */
  errors: Array<Error>;
  /** The saved role identifier. */
  roleIdentifier?: Maybe<RoleIdentifier>;
};

/** Autogenerated return type of SaveService */
export type SaveServicePayload = {
  __typename?: 'SaveServicePayload';
  errors: Array<Error>;
  services: Array<Service>;
};

/** Autogenerated return type of SaveSubscriber */
export type SaveSubscriberPayload = {
  __typename?: 'SaveSubscriberPayload';
  /** A list of errors that occured when saving the subscriber. */
  errors: Array<Error>;
  /** The saved subscriber. */
  subscriber?: Maybe<Subscriber>;
};

/** Autogenerated return type of SaveVideo */
export type SaveVideoPayload = {
  __typename?: 'SaveVideoPayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The saved Video. */
  video?: Maybe<Video>;
};

/** Autogenerated return type of SaveWebhook */
export type SaveWebhookPayload = {
  __typename?: 'SaveWebhookPayload';
  /** A list of errors that occurred while saving. */
  errors: Array<Error>;
  /** The saved Webhook. */
  webhook?: Maybe<Webhook>;
};

/** Represents a Segment Integration. */
export type Segment = Integration & {
  __typename?: 'Segment';
  /** The config for a Segment Integration. */
  config: SegmentConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SegmentConfig = {
  __typename?: 'SegmentConfig';
  /** The domain to load the segment script from. */
  segmentDomain?: Maybe<Scalars['String']['output']>;
  /** The key for the Segment integration. */
  segmentKey: Scalars['String']['output'];
};

/** Container that provides the current server time and the transitional steps during an event. */
export type Sequence = {
  __typename?: 'Sequence';
  /** The current UTC timestamp for the server. */
  serverTime: Scalars['Timestamp']['output'];
  /** An array of steps that represent a transition of state for an event. */
  steps: Array<Step>;
};

/** The type of sequence event */
export enum SequenceQueryType {
  /** feed type */
  FEED = 'FEED',
  /** service type */
  SERVICE = 'SERVICE',
  /** video type */
  VIDEO = 'VIDEO',
}

/** Represents a particular instance of an organization's services. */
export type Service = {
  __typename?: 'Service';
  /** Returns the channels and grant token for the service and authorized user. */
  communication?: Maybe<Communication>;
  /** The content for the service. */
  content?: Maybe<Content>;
  /** The day of the month that the service takes place. */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** The day of the week that the service takes place. */
  dayOfWeek?: Maybe<Scalars['String']['output']>;
  /** The ending date of the recurrence. */
  endRepeat?: Maybe<Scalars['Timestamp']['output']>;
  /** The time the service ends. */
  endTime?: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Returns the current channels for the service and authorized user.
   * @deprecated Deprecating in favor of new { service { communication } }
   */
  feed?: Maybe<Array<Channel>>;
  /** Whether or not the feed has started. */
  feedStarted?: Maybe<Scalars['Boolean']['output']>;
  /** The fetch time of the service. */
  fetchTime?: Maybe<Scalars['Timestamp']['output']>;
  /** The id of the service. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Get Metrics for Services */
  metrics: Array<ServiceMetric>;
  /** The Moment Instances for the provided service. */
  momentInstances: Array<MomentInstance>;
  /** The month of the year that the service takes place. */
  monthOfYear?: Maybe<Scalars['Int']['output']>;
  /** The id of the service's organization. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The recurrence of the service. */
  recurrence: RecurrenceEnum;
  /** The time of the service on the schedule. */
  scheduleTime?: Maybe<Scalars['Timestamp']['output']>;
  /** The sequence of the service. */
  sequence?: Maybe<Sequence>;
  /** The start time of the service. */
  startTime?: Maybe<Scalars['Timestamp']['output']>;
  /** The version history for this service and its service time. */
  versions: Array<Version>;
  /** The week of the month that the service takes place. */
  weekOfMonth?: Maybe<Scalars['Int']['output']>;
};

/** Represents a particular instance of an organization's services. */
export type ServiceCommunicationArgs = {
  refreshToken?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a particular instance of an organization's services. */
export type ServiceFeedArgs = {
  feedStarted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a particular instance of an organization's services. */
export type ServiceInput = {
  /** The day of the month that the service takes place. */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week that the service takes place. */
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  /** The ending date of the recurrence. */
  endRepeat?: InputMaybe<Scalars['Timestamp']['input']>;
  /** The end time of the service. */
  endTime?: InputMaybe<Scalars['Timestamp']['input']>;
  /** The id of the service. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The max number of occurrences the service has. */
  maxNumOccurrences?: InputMaybe<Scalars['Int']['input']>;
  /** The month of the year that the service takes place. */
  monthOfYear?: InputMaybe<Scalars['Int']['input']>;
  /** The recurrence of the service. */
  recurrence: RecurrenceEnum;
  /** The time of the service on the schedule. */
  scheduleTime: Scalars['Timestamp']['input'];
  /** The start time of the service. */
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  /** The week of the month that the service takes place. */
  weekOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** The year that the service takes place. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Service Metric. */
export type ServiceMetric = {
  __typename?: 'ServiceMetric';
  /** Average time watched in seconds. */
  avgTimeWatched: Scalars['Int']['output'];
  /** Number of attender chatters. */
  chattersAttenders: Scalars['Int']['output'];
  /** Number of host chatters. */
  chattersHosts: Scalars['Int']['output'];
  /** Number of hosts present. */
  hostsPresent: Scalars['Int']['output'];
  /** Number of direct messages. */
  msgsDirect: Scalars['Int']['output'];
  /** Number of hosts messages. */
  msgsHost: Scalars['Int']['output'];
  /** Number of prayer messages. */
  msgsPrayer: Scalars['Int']['output'];
  /** Number of public messages. */
  msgsPublic: Scalars['Int']['output'];
  /** Number of public messages by the hosts. */
  msgsPublicByHosts: Scalars['Int']['output'];
  /** The id of the organization. */
  organizationId: Scalars['ID']['output'];
  /** Number of salvations. */
  salvations: Scalars['Int']['output'];
  /** The id of the service. */
  serviceId: Scalars['String']['output'];
  timelinePrayerC?: Maybe<Scalars['String']['output']>;
  timelinePrayerT?: Maybe<Scalars['String']['output']>;
  timelineSubsPresentC: Scalars['String']['output'];
  timelineSubsPresentT: Scalars['String']['output'];
  /** Total time watched in seconds. */
  totalTimeWatchedSecs: Scalars['Int']['output'];
  viewers0s: Scalars['Int']['output'];
  viewers3s: Scalars['Int']['output'];
  viewers5m: Scalars['Int']['output'];
  viewers10m: Scalars['Int']['output'];
  viewers10s: Scalars['Int']['output'];
  viewers15m: Scalars['Int']['output'];
  viewers20m: Scalars['Int']['output'];
  viewers25m: Scalars['Int']['output'];
  viewers30m: Scalars['Int']['output'];
  viewers30s: Scalars['Int']['output'];
  viewers60s: Scalars['Int']['output'];
};

/** A connection type for returning paginated services */
export type ServicesConnection = ConnectionInterface & {
  __typename?: 'ServicesConnection';
  aggregate: Aggregate;
  services: Array<Service>;
};

/** Filter arguments for the ServiceConnection */
export type ServicesConnectionFilter = {
  /** Filter services on presence of content */
  hasContent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a Stack Adapt Integration */
export type StackAdapt = Integration & {
  __typename?: 'StackAdapt';
  /** The configuration for the Stack Adapt Integration. */
  config: StackAdaptConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type StackAdaptConfig = {
  __typename?: 'StackAdaptConfig';
  /** The Stack Adapt ID */
  stackAdaptId: Scalars['String']['output'];
};

/** Represents a transition of state for a service at a specific time. */
export type Step = {
  __typename?: 'Step';
  /** The UTC unix timestamp for when the data should be fetched for this state. */
  fetchTime: Scalars['Timestamp']['output'];
  /** An array of keys representing the data that will change for this state. */
  queries: Array<SequenceQueryType>;
  /** The UTC unix timestamp for when the event transisions to this state. */
  transitionTime: Scalars['Timestamp']['output'];
};

/** Autogenerated return type of SubmitMomentAction */
export type SubmitMomentActionPayload = {
  __typename?: 'SubmitMomentActionPayload';
  /** The Moment action. */
  action?: Maybe<MomentAction>;
  /** A list of errors that occurred. */
  errors: Array<Error>;
};

/** Represents a subscriber in the system */
export type Subscriber = {
  __typename?: 'Subscriber';
  /** The areas of ministry for the subscriber. */
  areaOfMinistries: Array<AreaOfMinistry>;
  /** The url of the subscribers avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** An array of channel_ids that the subscriber is subscribed to. */
  channelIds: Array<Scalars['ID']['output']>;
  /** The city of the subscriber (i.e. - Edmond) */
  city?: Maybe<Scalars['String']['output']>;
  /** The country code of the subscriber (i.e. - US) */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The country name of the subscriber (i.e. - united states) */
  countryName?: Maybe<Scalars['String']['output']>;
  /** The creation date of the subscriber (ISO-8601) */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The email of the subscriber */
  email?: Maybe<Scalars['String']['output']>;
  /** Does the user consent to being emailed. */
  emailConsent?: Maybe<Scalars['Boolean']['output']>;
  /** The first name of the subscriber */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The GDPR indicator for the subscriber */
  gdpr?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the subscriber */
  id: Scalars['ID']['output'];
  /** The expired data for a newly invited subscriber (ISO-8601) */
  inviteExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether or not an invite is pending. */
  invitePending: Scalars['Boolean']['output'];
  /** The IP of the subscriber */
  ip?: Maybe<Scalars['String']['output']>;
  /** The language of the subscriber */
  language?: Maybe<Scalars['String']['output']>;
  /** The last time the subscriber interacted with the service. */
  lastActivity?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The last name of the subscriber */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Whether or not the subscriber has been muted. */
  muted: Scalars['Boolean']['output'];
  /** Date until subscriber will be muted. */
  mutedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The nickname of the subscriber */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The id of the subscriber's organization */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** The preferences of the subscriber */
  preferences: SubscriberPreferences;
  /** The authentication key the subscriber can use to connect to pubnub. */
  pubnubAuthKey: Scalars['String']['output'];
  /** The region of the subscriber (i.e. - OK) */
  region?: Maybe<Scalars['String']['output']>;
  /** The role assigned to the subscriber */
  role?: Maybe<Role>;
  /** The role identifier of the subscriber. */
  roleIdentifier?: Maybe<RoleIdentifier>;
  /** The role type assigned to the subscriber, returned as a string */
  roleType?: Maybe<Scalars['String']['output']>;
  /** Returns connected and connectedAt fields for the subscriber. */
  stats: SubscriberStats;
  /**
   * The subscriptions of the subscriber
   * @deprecated Removing subscriptions
   */
  subscriptions: Array<ProfileSubscription>;
};

export type SubscriberChannelStats = {
  __typename?: 'SubscriberChannelStats';
  /** The amount of prayer channels the subscriber is in */
  prayer: Scalars['Int']['output'];
};

/** The connection type for Subscriber. */
export type SubscriberConnection = {
  __typename?: 'SubscriberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Subscriber>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total connected subscribers. */
  totalConnected: Scalars['Int']['output'];
  /** Total results count. */
  totalCount: Scalars['Int']['output'];
};

/** Default attributes */
export type SubscriberDefaultsInput = {
  /** The default avatar of the user */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** The default nickname of the user */
  nickname?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type SubscriberEdge = {
  __typename?: 'SubscriberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Subscriber>;
};

export enum SubscriberFieldType {
  EMAIL = 'EMAIL',
}

/** Attributes for creating or updating a user. */
export type SubscriberInput = {
  /** The areas of ministry for the subscriber. */
  areaOfMinistries?: InputMaybe<Array<AreaOfMinistriesInput>>;
  /** The url of the users avatar */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** The city of the subscriber (i.e. - Edmond) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the subscriber (i.e. - US) */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The country name of the subscriber (i.e. - united states) */
  countryName?: InputMaybe<Scalars['String']['input']>;
  /** The defaults of the user */
  defaults?: InputMaybe<SubscriberDefaultsInput>;
  /** The email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Does the user consent to be emailed. */
  emailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The first name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The GDPR indicator for the subscriber */
  gdpr?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the user */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The IP of the subscriber */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** The language of the subscriber */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the subscriber has been muted. */
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The nickname of the user */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** The password of the subscriber */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The preferences of the user */
  preferences?: InputMaybe<SubscriberPreferencesInput>;
  /** The region of the subscriber (i.e. - OK) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The role of the subscriber */
  roleId?: InputMaybe<Scalars['ID']['input']>;
  /** The role identifier of the subscriber */
  roleIdentifierId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SubscriberOrderField {
  CREATED_AT = 'CREATED_AT',
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  IDENTIFIER = 'IDENTIFIER',
  LAST_ACTIVITY = 'LAST_ACTIVITY',
  LAST_NAME = 'LAST_NAME',
  NICKNAME = 'NICKNAME',
  ROLE = 'ROLE',
}

/** Represents preferences associated with a subscriber */
export type SubscriberPreferences = {
  __typename?: 'SubscriberPreferences';
  /** The skin tone index for reactions. */
  skinTone: Scalars['Int']['output'];
  /** The preferred text mode of the subscriber */
  textMode?: Maybe<TextMode>;
};

/** Attributes for creating or updating preferences. */
export type SubscriberPreferencesInput = {
  /** The skin tone index for reactions. */
  skinTone?: InputMaybe<Scalars['Int']['input']>;
  /** The preferred text mode of the subscriber */
  textMode?: InputMaybe<TextMode>;
};

/** Subscriber Sort Order */
export type SubscriberSortOrder = {
  /** Order of the sort */
  direction: OrderDirection;
  /** The attribute to sort by  */
  field: SubscriberOrderField;
};

/** Collection of stats around a subscribers activity in a public channel */
export type SubscriberStats = {
  __typename?: 'SubscriberStats';
  /** Returns channel stats for a subscriber */
  channels: SubscriberChannelStats;
  /** Whether or not a subscriber is connected */
  connected?: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of when a subscriber joined the public channel */
  connectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Passing the id of the subscriber along with the stats. */
  subscriberId: Scalars['ID']['output'];
};

export enum SubscriberType {
  /** Subscriber with admin role. */
  ADMIN = 'ADMIN',
  /** Subscriber without authentication. Will not have an email but has chosen a nickname. */
  ALIAS_GUEST = 'ALIAS_GUEST',
  /** Subscriber without authentication. Will not have an email or a nickname. */
  ANONYMOUS_GUEST = 'ANONYMOUS_GUEST',
  /** Subscriber with global role. */
  GLOBAL = 'GLOBAL',
  /** Deprecated - old Guest type that includes both anonymous and alias. */
  GUEST = 'GUEST',
  /** Subscriber with host role. */
  HOST = 'HOST',
  /** Subscriber with owner role. */
  OWNER = 'OWNER',
  SERVICE = 'SERVICE',
  /** Subscriber with authentication but no role. */
  USER = 'USER',
}

export type SubscribersConnection = BaseConnectionInterface & {
  __typename?: 'SubscribersConnection';
  aggregate: Aggregate;
  subscribers: Array<Subscriber>;
};

export type SubscribersFilter = {
  /** The channel ID to scope by */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** The channel type */
  channelType?: InputMaybe<Scalars['String']['input']>;
  /** Filter subscribers by muted */
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The organization ID to scope by */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The search string */
  search?: InputMaybe<Scalars['String']['input']>;
  subscriberTypeIn?: InputMaybe<Array<SubscriberType>>;
};

/** Represents the success of a query */
export type Success = {
  __typename?: 'Success';
  /** The errors that occurred. */
  errors: Array<Error>;
  /** The success of the operation */
  success: Scalars['Boolean']['output'];
};

/** Represents a symbol */
export type Symbol = {
  __typename?: 'Symbol';
  /** The ID of the symbol */
  id: Scalars['String']['output'];
  /** The name of the symbol */
  name: Scalars['String']['output'];
  /** The native representation of the symbol */
  native: Scalars['String']['output'];
  /** The unicode representation of the symbol */
  unified: Scalars['String']['output'];
};

/** Represents a symbol input */
export type SymbolInput = {
  /** The ID of the symbol */
  id: Scalars['String']['input'];
  /** The name of the symbol */
  name: Scalars['String']['input'];
  /** The native representation of the symbol */
  native: Scalars['String']['input'];
  /** The unicode representation of the symbol */
  unified: Scalars['String']['input'];
};

export enum TextMode {
  /** Comfortable text mode. */
  COMFORTABLE = 'COMFORTABLE',
  /** Compact text mode. */
  COMPACT = 'COMPACT',
}

export type Transcript = {
  __typename?: 'Transcript';
  createdAt: Scalars['String']['output'];
  directChats: Scalars['Int']['output'];
  expires: Scalars['String']['output'];
  id: Scalars['String']['output'];
  livePrayers: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  scheduleTime: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Translation = {
  __typename?: 'Translation';
  languageCode: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Represents a version/audit record for tracking changes to a record. */
export type Version = {
  __typename?: 'Version';
  /** The changes made in this version (before/after for each changed attribute). */
  changes?: Maybe<Scalars['JSON']['output']>;
  /** When this version was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The type of event (create, update, future, current, all, build_schedule). */
  event: Scalars['String']['output'];
  /** The unique identifier of the version. */
  id: Scalars['ID']['output'];
  /** The type of record this version belongs to. */
  itemType: VersionItemType;
  /** The subscriber who made this change. */
  subscriber?: Maybe<Subscriber>;
  /** The subscriber ID if whodunnit is a valid UUID, otherwise nil. */
  subscriberId?: Maybe<Scalars['ID']['output']>;
  /** The raw identifier of who made this change (subscriber ID, worker name, or nil). */
  whodunnit?: Maybe<Scalars['String']['output']>;
};

/** The type of record a version belongs to */
export enum VersionItemType {
  /** Content record */
  CONTENT = 'CONTENT',
  /** Organization record */
  ORGANIZATION = 'ORGANIZATION',
  /** Service record */
  SERVICE = 'SERVICE',
  /** ServiceTime record */
  SERVICE_TIME = 'SERVICE_TIME',
}

/** Represents a video. */
export type Video = {
  __typename?: 'Video';
  /** The ID of the video. */
  id: Scalars['ID']['output'];
  options?: Maybe<VideoOptions>;
  /** The source content of the video, could be embed code or url. */
  source: Scalars['String']['output'];
  /** The type of video. */
  type: VideoType;
  /** The URL of the video. */
  url: Scalars['String']['output'];
};

/** Represents a video. */
export type VideoInput = {
  /** The id of the content the video belongs to. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the video. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The source of the video. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** The type of video. */
  type?: InputMaybe<VideoType>;
};

/** Represents the video Options. */
export type VideoOptions = {
  __typename?: 'VideoOptions';
  /** Whether or not to autoplay the video. */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to loop the video. */
  loop?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the video Options. */
export type VideoOptionsInput = {
  /** Whether or not to autoplay the video. */
  autoplay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to loop the video. */
  loop?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The type of video */
export enum VideoType {
  /** live video */
  LIVE = 'LIVE',
  /** no video */
  NONE = 'NONE',
  /** offline */
  OFFLINE = 'OFFLINE',
  /** simulated video */
  SIMULATED = 'SIMULATED',
}

/** Visual mode options for the organization. */
export enum VisualModeOption {
  /** Dark mode for the organization. */
  DARK = 'DARK',
  /** Light mode for the organization. */
  LIGHT = 'LIGHT',
}

export type Webhook = {
  __typename?: 'Webhook';
  /** Status for the Webhooks integration */
  active: Scalars['Boolean']['output'];
  /** Whether or not this webhook should publish anonymous webhook_events */
  anonymousEvents: Scalars['Boolean']['output'];
  /** Event types for the Webhooks Integration. */
  events: Array<WebhookEventType>;
  /** Id for the Webhook */
  id: Scalars['ID']['output'];
  /** Integration for the Webhooks integration */
  integration?: Maybe<WebhooksIntegration>;
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** Secret key to verify calls. */
  secretKey: Scalars['String']['output'];
  /** The updated at field of the webhook */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Url to send events to. */
  url: Scalars['String']['output'];
};

export type WebhookEvent = {
  __typename?: 'WebhookEvent';
  /** The date the Webhook Event was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Data for the Webhook Event */
  data: Scalars['JSON']['output'];
  /** Id for the Webhook Event */
  id: Scalars['ID']['output'];
  /** Job Id for the Webhook Event */
  jobId?: Maybe<Scalars['String']['output']>;
  /** Org Id for the Webhook Event */
  organizationId: Scalars['ID']['output'];
  /** Response for the Webhook Event */
  response?: Maybe<Scalars['JSON']['output']>;
  /** Response code for the Webhook Event */
  responseCode?: Maybe<Scalars['Int']['output']>;
  /** Status for the Webhook Event */
  status: WebhookEventStatus;
  /** The type of webhook event */
  type?: Maybe<WebhookEventType>;
  /** The last time the Webhook Event was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Webhook for the Webhook Event */
  webhook: Webhook;
};

/** The connection type for WebhookEvent. */
export type WebhookEventConnection = {
  __typename?: 'WebhookEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WebhookEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WebhookEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total results count */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookEventEdge = {
  __typename?: 'WebhookEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WebhookEvent>;
};

export enum WebhookEventStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PAUSED = 'PAUSED',
  QUEUED = 'QUEUED',
  RETRYING = 'RETRYING',
}

export enum WebhookEventType {
  MOMENT_INTERACTED = 'MOMENT_INTERACTED',
  MOMENT_LIKED = 'MOMENT_LIKED',
  MOMENT_SHARED = 'MOMENT_SHARED',
  PRAYER_ACCEPTED = 'PRAYER_ACCEPTED',
  PRAYER_REQUESTED = 'PRAYER_REQUESTED',
  SERVICE_ATTENDED = 'SERVICE_ATTENDED',
  SERVICE_CHATTED = 'SERVICE_CHATTED',
  SERVICE_SERVED = 'SERVICE_SERVED',
  USER_CREATED = 'USER_CREATED',
  USER_DELETED = 'USER_DELETED',
  USER_MUTED = 'USER_MUTED',
  USER_UPDATED = 'USER_UPDATED',
}

export type WebhookEventsFilter = {
  /** logically OR another filter */
  OR?: InputMaybe<Array<WebhookEventsFilter>>;
  /** job status should equal */
  statusEq?: InputMaybe<WebhookEventStatus>;
  /** job status should be in */
  statusIn?: InputMaybe<Array<WebhookEventStatus>>;
  /** the webhook id */
  webhookId?: InputMaybe<Scalars['ID']['input']>;
};

/** Attributes for creating or updating a Webhook. */
export type WebhookInput = {
  /** Webhook enabled status. */
  active: Scalars['Boolean']['input'];
  /** Whether or not this webhook queues anonymous events. */
  anonymousEvents?: InputMaybe<Scalars['Boolean']['input']>;
  /** The evevnts for the Webhook. */
  events: Array<WebhookEventType>;
  /** The unique ID of the Webhook. */
  id: Scalars['ID']['input'];
  /** Integration Id of the webhook. */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  /** The secret key of the Webhook. */
  secretKey: Scalars['String']['input'];
  /** The url of the Webhook. */
  url: Scalars['String']['input'];
};

export type WebhooksConfig = {
  __typename?: 'WebhooksConfig';
  /** The webhooks for the Webhooks Integration. */
  webhooks: Array<Webhook>;
};

/** Represents a Webhook Integration. */
export type WebhooksIntegration = Integration & {
  __typename?: 'WebhooksIntegration';
  /** The config for a Webhook Integration. */
  config: WebhooksConfig;
  /** The date the Integration was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The enabled status of the Integration. */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the Integration. */
  id: Scalars['ID']['output'];
  /** The organization the Integration belongs to. */
  organizationId: Scalars['ID']['output'];
  /** The type of the Integration. */
  type: IntegrationType;
  /** The last time the Integration was updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents the welcome banner for an organization. */
export type WelcomeBanner = {
  __typename?: 'WelcomeBanner';
  /** The body text of the welcome banner. */
  bodyText?: Maybe<Scalars['String']['output']>;
  /** Whether the welcome banner is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The title text of the welcome banner. */
  titleText?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating or updating a WelcomeBanner. */
export type WelcomeBannerInput = {
  /** The body text of the welcome banner. */
  bodyText?: InputMaybe<Scalars['String']['input']>;
  /** Whether the welcome banner is enabled. */
  enabled: Scalars['Boolean']['input'];
  /** The title text of the welcome banner. */
  titleText?: InputMaybe<Scalars['String']['input']>;
};

export enum WindowType {
  IFRAME = 'IFRAME',
  NEW_TAB = 'NEW_TAB',
}

export type RoleFieldsFragment = {
  __typename?: 'Role';
  id: string;
  name: string;
  label: string;
  type: RoleType;
};

export type RoleIdentifierFieldsFragment = {
  __typename?: 'RoleIdentifier';
  id: string;
  key: string;
  type: RoleIdentifierType;
  label?: string | null;
};

export type MomentTemplateFields_ConnectMoment_Fragment = {
  __typename: 'ConnectMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: {
    __typename?: 'ConnectMomentOptions';
    text: string;
    windowType: WindowType;
    connectUrl: string;
  };
};

export type MomentTemplateFields_GivingMoment_Fragment = {
  __typename: 'GivingMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: {
    __typename?: 'GivingMomentOptions';
    text: string;
    src: string;
    windowType: WindowType;
  };
};

export type MomentTemplateFields_ImageMoment_Fragment = {
  __typename: 'ImageMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: {
    __typename?: 'ImageMomentOptions';
    altText?: string | null;
    imageUrl: string;
    shareText?: string | null;
  };
};

export type MomentTemplateFields_InviteMoment_Fragment = {
  __typename: 'InviteMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
};

export type MomentTemplateFields_NextStepsMoment_Fragment = {
  __typename: 'NextStepsMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: {
    __typename?: 'NextStepsMomentOptions';
    buttonText: string;
    description: string;
    iconUrl?: string | null;
    leadInText?: string | null;
    text: string;
    url?: string | null;
  };
};

export type MomentTemplateFields_PrayerMoment_Fragment = {
  __typename: 'PrayerMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
};

export type MomentTemplateFields_QuoteMoment_Fragment = {
  __typename: 'QuoteMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
};

export type MomentTemplateFields_ResponseMoment_Fragment = {
  __typename: 'ResponseMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: {
    __typename?: 'ResponseMomentOptions';
    text: string;
    buttonText: string;
    symbol: { __typename?: 'Symbol'; id: string; name: string; native: string; unified: string };
  };
};

export type MomentTemplateFields_SalvationMoment_Fragment = {
  __typename: 'SalvationMoment';
  id: string;
  type: MomentType;
  includedInFutureServices: boolean;
  updatedAt: any;
  options: {
    __typename?: 'SalvationMomentOptions';
    salvationMomentFollowUpType: SalvationMomentFollowUpType;
    url?: string | null;
    labels?: {
      __typename?: 'SalvationMomentLabels';
      prompt?: string | null;
      response?: string | null;
      buttonText?: string | null;
      celebrationMessage?: string | null;
    } | null;
  };
};

export type MomentTemplateFieldsFragment =
  | MomentTemplateFields_ConnectMoment_Fragment
  | MomentTemplateFields_GivingMoment_Fragment
  | MomentTemplateFields_ImageMoment_Fragment
  | MomentTemplateFields_InviteMoment_Fragment
  | MomentTemplateFields_NextStepsMoment_Fragment
  | MomentTemplateFields_PrayerMoment_Fragment
  | MomentTemplateFields_QuoteMoment_Fragment
  | MomentTemplateFields_ResponseMoment_Fragment
  | MomentTemplateFields_SalvationMoment_Fragment;

export type MetricTemplateFieldsFragment = {
  __typename: 'ServiceMetric';
  serviceId: string;
  salvations: number;
  msgsPublicByHosts: number;
  msgsPublic: number;
  msgsPrayer: number;
  msgsHost: number;
  msgsDirect: number;
  chattersHosts: number;
  chattersAttenders: number;
  totalTimeWatchedSecs: number;
  avgTimeWatched: number;
  viewers0s: number;
  viewers3s: number;
  viewers10s: number;
  viewers30s: number;
  viewers60s: number;
  viewers5m: number;
  viewers10m: number;
  viewers15m: number;
  viewers20m: number;
  viewers25m: number;
  viewers30m: number;
  hostsPresent: number;
  timelineSubsPresentT: string;
  timelineSubsPresentC: string;
  timelinePrayerT?: string | null;
  timelinePrayerC?: string | null;
};

export type CurrentSubscriberFieldsFragment = {
  __typename?: 'Subscriber';
  id: string;
  nickname?: string | null;
  avatar?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  emailConsent?: boolean | null;
  roleIdentifier?: {
    __typename?: 'RoleIdentifier';
    id: string;
    type: RoleIdentifierType;
    key: string;
    label?: string | null;
  } | null;
  role?: {
    __typename?: 'Role';
    id: string;
    type: RoleType;
    name: string;
    permissions: Array<{ __typename?: 'Permission'; key: string }>;
  } | null;
};

export type CurrentSubscriberQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentSubscriberQuery = {
  __typename?: 'Query';
  currentSubscriber?: {
    __typename?: 'Subscriber';
    id: string;
    nickname?: string | null;
    avatar?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    emailConsent?: boolean | null;
    roleIdentifier?: {
      __typename?: 'RoleIdentifier';
      id: string;
      type: RoleIdentifierType;
      key: string;
      label?: string | null;
    } | null;
    role?: {
      __typename?: 'Role';
      id: string;
      type: RoleType;
      name: string;
      permissions: Array<{ __typename?: 'Permission'; key: string }>;
    } | null;
  } | null;
};

export type SubscriberFieldsFragment = {
  __typename?: 'Subscriber';
  id: string;
  nickname?: string | null;
  avatar?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  muted: boolean;
  mutedUntil?: any | null;
  lastActivity?: any | null;
  emailConsent?: boolean | null;
  createdAt?: any | null;
  inviteExpiresAt?: any | null;
  invitePending: boolean;
  roleIdentifier?: {
    __typename?: 'RoleIdentifier';
    id: string;
    key: string;
    type: RoleIdentifierType;
    label?: string | null;
  } | null;
  role?: { __typename?: 'Role'; id: string; name: string; label: string; type: RoleType } | null;
};

export type SubscriberPageInfoFieldsFragment = {
  __typename?: 'PageInfo';
  endCursor?: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: string | null;
};

export type SubscriberNodeFieldsFragment = {
  __typename?: 'SubscriberEdge';
  node?: {
    __typename?: 'Subscriber';
    id: string;
    nickname?: string | null;
    avatar?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    muted: boolean;
    mutedUntil?: any | null;
    lastActivity?: any | null;
    emailConsent?: boolean | null;
    createdAt?: any | null;
    inviteExpiresAt?: any | null;
    invitePending: boolean;
    roleIdentifier?: {
      __typename?: 'RoleIdentifier';
      id: string;
      key: string;
      type: RoleIdentifierType;
      label?: string | null;
    } | null;
    role?: { __typename?: 'Role'; id: string; name: string; label: string; type: RoleType } | null;
  } | null;
};

export type SubscriberQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SubscriberQuery = {
  __typename?: 'Query';
  subscriber?: {
    __typename?: 'Subscriber';
    id: string;
    nickname?: string | null;
    avatar?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    muted: boolean;
    mutedUntil?: any | null;
    lastActivity?: any | null;
    emailConsent?: boolean | null;
    createdAt?: any | null;
    inviteExpiresAt?: any | null;
    invitePending: boolean;
    roleIdentifier?: {
      __typename?: 'RoleIdentifier';
      id: string;
      key: string;
      type: RoleIdentifierType;
      label?: string | null;
    } | null;
    role?: { __typename?: 'Role'; id: string; name: string; label: string; type: RoleType } | null;
  } | null;
};

export type SaveSubscriberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SubscriberInput;
}>;

export type SaveSubscriberMutation = {
  __typename?: 'Mutation';
  saveSubscriber: {
    __typename?: 'SaveSubscriberPayload';
    subscriber?: { __typename?: 'Subscriber'; id: string } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type UnmuteSubscriberMutationVariables = Exact<{
  subscriberId: Scalars['ID']['input'];
}>;

export type UnmuteSubscriberMutation = {
  __typename?: 'Mutation';
  unmuteSubscriber: {
    __typename?: 'Success';
    success: boolean;
    errors: Array<{ __typename?: 'Error'; code: string; message?: string | null }>;
  };
};

export type DeleteSubscriberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteSubscriberMutation = {
  __typename?: 'Mutation';
  deleteSubscriber: {
    __typename?: 'DeleteSubscriberPayload';
    subscriber?: { __typename?: 'Subscriber'; id: string } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;

export type InviteUserMutation = {
  __typename?: 'Mutation';
  inviteUser: {
    __typename?: 'InviteUserPayload';
    subscriber?: {
      __typename?: 'Subscriber';
      email?: string | null;
      id: string;
      invitePending: boolean;
      inviteExpiresAt?: any | null;
    } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type ReinviteUserMutationVariables = Exact<{
  input: ReinviteUserInput;
}>;

export type ReinviteUserMutation = {
  __typename?: 'Mutation';
  reinviteUser: {
    __typename?: 'ReinviteUserPayload';
    subscriber?: {
      __typename?: 'Subscriber';
      id: string;
      invitePending: boolean;
      inviteExpiresAt?: any | null;
    } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RequestPasswordResetMutation = {
  __typename?: 'Mutation';
  requestPasswordReset: {
    __typename?: 'Success';
    success: boolean;
    errors: Array<{ __typename?: 'Error'; code: string; message?: string | null }>;
  };
};

export type ApperanceFieldsFragment = {
  __typename?: 'Appearance';
  favicon?: string | null;
  headerBackgroundColor: string;
  headerTextColor: string;
  navigationLinkCase: NavigationLinkOption;
  hideViewershipMetric: boolean;
  logo?: string | null;
  visualMode: VisualModeOption;
  darkLogo?: string | null;
  enableDarkMode: boolean;
};

export type LinkFieldsFragment = {
  __typename?: 'OrganizationLink';
  id: string;
  key: string;
  label: string;
  url: string;
};

export type OrganizationFieldsFragment = {
  __typename?: 'Organization';
  id: string;
  name: string;
  website?: string | null;
  timezone: string;
  address: string;
  addressTwo?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  slug: string;
  emailConsent?: EmailConsentType | null;
  privacyUrl?: string | null;
  termsUrl?: string | null;
  customDomain?: string | null;
  slugDomain: string;
  roles: Array<{ __typename?: 'Role'; id: string; name: string; label: string; type: RoleType }>;
  appearance: {
    __typename?: 'Appearance';
    favicon?: string | null;
    headerBackgroundColor: string;
    headerTextColor: string;
    navigationLinkCase: NavigationLinkOption;
    hideViewershipMetric: boolean;
    logo?: string | null;
    visualMode: VisualModeOption;
    darkLogo?: string | null;
    enableDarkMode: boolean;
  };
  roleIdentifiers: Array<{
    __typename?: 'RoleIdentifier';
    id: string;
    key: string;
    type: RoleIdentifierType;
    label?: string | null;
  }>;
  links: Array<{
    __typename?: 'OrganizationLink';
    id: string;
    key: string;
    label: string;
    url: string;
  }>;
  loginBanner: {
    __typename?: 'LoginBanner';
    bodyText?: string | null;
    buttonText?: string | null;
    enabled: boolean;
  };
  welcomeBanner: {
    __typename?: 'WelcomeBanner';
    bodyText?: string | null;
    enabled: boolean;
    titleText?: string | null;
  };
};

export type CurrentOrganizationQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    name: string;
    website?: string | null;
    timezone: string;
    address: string;
    addressTwo?: string | null;
    city: string;
    state: string;
    zip: string;
    country: string;
    slug: string;
    emailConsent?: EmailConsentType | null;
    privacyUrl?: string | null;
    termsUrl?: string | null;
    customDomain?: string | null;
    slugDomain: string;
    roles: Array<{ __typename?: 'Role'; id: string; name: string; label: string; type: RoleType }>;
    appearance: {
      __typename?: 'Appearance';
      favicon?: string | null;
      headerBackgroundColor: string;
      headerTextColor: string;
      navigationLinkCase: NavigationLinkOption;
      hideViewershipMetric: boolean;
      logo?: string | null;
      visualMode: VisualModeOption;
      darkLogo?: string | null;
      enableDarkMode: boolean;
    };
    roleIdentifiers: Array<{
      __typename?: 'RoleIdentifier';
      id: string;
      key: string;
      type: RoleIdentifierType;
      label?: string | null;
    }>;
    links: Array<{
      __typename?: 'OrganizationLink';
      id: string;
      key: string;
      label: string;
      url: string;
    }>;
    loginBanner: {
      __typename?: 'LoginBanner';
      bodyText?: string | null;
      buttonText?: string | null;
      enabled: boolean;
    };
    welcomeBanner: {
      __typename?: 'WelcomeBanner';
      bodyText?: string | null;
      enabled: boolean;
      titleText?: string | null;
    };
  } | null;
};

export type OrganizationReportingFieldsFragment = {
  __typename?: 'Organization';
  id: string;
  transcripts: Array<{
    __typename?: 'Transcript';
    scheduleTime: string;
    title: string;
    livePrayers: number;
    directChats: number;
    expires: string;
    url: string;
  }>;
  reportingConfig?: {
    __typename?: 'ReportingConfig';
    id: string;
    transcriptsEnabled: boolean;
    serviceReportRecipients?: Array<string> | null;
  } | null;
};

export type CurrentOrganizationReportingQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationReportingQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    transcripts: Array<{
      __typename?: 'Transcript';
      scheduleTime: string;
      title: string;
      livePrayers: number;
      directChats: number;
      expires: string;
      url: string;
    }>;
    reportingConfig?: {
      __typename?: 'ReportingConfig';
      id: string;
      transcriptsEnabled: boolean;
      serviceReportRecipients?: Array<string> | null;
    } | null;
  } | null;
};

export type CurrentOrganizationInfoFieldsFragment = {
  __typename?: 'Organization';
  id: string;
  name: string;
  website?: string | null;
  timezone: string;
  address: string;
  addressTwo?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  emailConsent?: EmailConsentType | null;
  privacyUrl?: string | null;
  termsUrl?: string | null;
};

export type CurrentOrganizationInfoQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationInfoQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    name: string;
    website?: string | null;
    timezone: string;
    address: string;
    addressTwo?: string | null;
    city: string;
    state: string;
    zip: string;
    country: string;
    emailConsent?: EmailConsentType | null;
    privacyUrl?: string | null;
    termsUrl?: string | null;
  } | null;
};

export type OrganizationOfflineFieldsFragment = {
  __typename?: 'Organization';
  id: string;
  offlinePrayerRecipients: Array<string>;
  offlineContent?:
    | { __typename: 'OfflineImage'; url?: string | null; type: OfflineContentType }
    | {
        __typename: 'OfflineVideo';
        source?: string | null;
        url?: string | null;
        type: OfflineContentType;
        options: { __typename?: 'VideoOptions'; autoplay?: boolean | null; loop?: boolean | null };
      }
    | null;
};

export type CurrentOrganizationOfflineQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationOfflineQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    offlinePrayerRecipients: Array<string>;
    offlineContent?:
      | { __typename: 'OfflineImage'; url?: string | null; type: OfflineContentType }
      | {
          __typename: 'OfflineVideo';
          source?: string | null;
          url?: string | null;
          type: OfflineContentType;
          options: {
            __typename?: 'VideoOptions';
            autoplay?: boolean | null;
            loop?: boolean | null;
          };
        }
      | null;
  } | null;
};

export type CurrentOrganizationDomainQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationDomainQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    customDomain?: string | null;
    slug: string;
  } | null;
};

export type CurrentOrganizationAppearanceQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationAppearanceQuery = {
  __typename?: 'Query';
  links: Array<{ __typename?: 'Link'; id: string; key: string; label: string }>;
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    name: string;
    appearance: {
      __typename?: 'Appearance';
      favicon?: string | null;
      headerBackgroundColor: string;
      headerTextColor: string;
      navigationLinkCase: NavigationLinkOption;
      hideViewershipMetric: boolean;
      logo?: string | null;
      visualMode: VisualModeOption;
      darkLogo?: string | null;
      enableDarkMode: boolean;
    };
    links: Array<{
      __typename?: 'OrganizationLink';
      id: string;
      key: string;
      label: string;
      url: string;
    }>;
    loginBanner: {
      __typename?: 'LoginBanner';
      bodyText?: string | null;
      buttonText?: string | null;
      enabled: boolean;
    };
    welcomeBanner: {
      __typename?: 'WelcomeBanner';
      bodyText?: string | null;
      enabled: boolean;
      titleText?: string | null;
    };
    versions: Array<{
      __typename?: 'OrganizationVersion';
      id: string;
      changes?: any | null;
      createdAt: any;
      event: string;
      whodunnit?: string | null;
      itemType: OrganizationVersionItemType;
      subscriberId?: string | null;
      subscriber?: {
        __typename?: 'Subscriber';
        id: string;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }>;
  } | null;
};

export type SaveOrganizationFieldsFragment = {
  __typename?: 'Organization';
  id: string;
  name: string;
  website?: string | null;
  customDomain?: string | null;
  timezone: string;
  address: string;
  addressTwo?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  slug: string;
  emailConsent?: EmailConsentType | null;
  privacyUrl?: string | null;
  termsUrl?: string | null;
  offlinePrayerRecipients: Array<string>;
  offlineVideoUrl?: string | null;
  shareImage?: string | null;
  appearance: {
    __typename?: 'Appearance';
    favicon?: string | null;
    headerBackgroundColor: string;
    headerTextColor: string;
    navigationLinkCase: NavigationLinkOption;
    hideViewershipMetric: boolean;
    logo?: string | null;
    visualMode: VisualModeOption;
    darkLogo?: string | null;
    enableDarkMode: boolean;
  };
  links: Array<{
    __typename?: 'OrganizationLink';
    id: string;
    key: string;
    label: string;
    url: string;
  }>;
  loginBanner: {
    __typename?: 'LoginBanner';
    bodyText?: string | null;
    buttonText?: string | null;
    enabled: boolean;
  };
  welcomeBanner: {
    __typename?: 'WelcomeBanner';
    bodyText?: string | null;
    enabled: boolean;
    titleText?: string | null;
  };
  offlineContent?:
    | { __typename?: 'OfflineImage'; url?: string | null; type: OfflineContentType }
    | {
        __typename?: 'OfflineVideo';
        source?: string | null;
        url?: string | null;
        type: OfflineContentType;
        options: { __typename?: 'VideoOptions'; autoplay?: boolean | null; loop?: boolean | null };
      }
    | null;
};

export type SaveOrganizationMutationVariables = Exact<{
  input: OrganizationInput;
}>;

export type SaveOrganizationMutation = {
  __typename?: 'Mutation';
  saveOrganization?: {
    __typename?: 'SaveOrganizationPayload';
    organization?: {
      __typename?: 'Organization';
      id: string;
      name: string;
      website?: string | null;
      customDomain?: string | null;
      timezone: string;
      address: string;
      addressTwo?: string | null;
      city: string;
      state: string;
      zip: string;
      country: string;
      slug: string;
      emailConsent?: EmailConsentType | null;
      privacyUrl?: string | null;
      termsUrl?: string | null;
      offlinePrayerRecipients: Array<string>;
      offlineVideoUrl?: string | null;
      shareImage?: string | null;
      appearance: {
        __typename?: 'Appearance';
        favicon?: string | null;
        headerBackgroundColor: string;
        headerTextColor: string;
        navigationLinkCase: NavigationLinkOption;
        hideViewershipMetric: boolean;
        logo?: string | null;
        visualMode: VisualModeOption;
        darkLogo?: string | null;
        enableDarkMode: boolean;
      };
      links: Array<{
        __typename?: 'OrganizationLink';
        id: string;
        key: string;
        label: string;
        url: string;
      }>;
      loginBanner: {
        __typename?: 'LoginBanner';
        bodyText?: string | null;
        buttonText?: string | null;
        enabled: boolean;
      };
      welcomeBanner: {
        __typename?: 'WelcomeBanner';
        bodyText?: string | null;
        enabled: boolean;
        titleText?: string | null;
      };
      offlineContent?:
        | { __typename?: 'OfflineImage'; url?: string | null; type: OfflineContentType }
        | {
            __typename?: 'OfflineVideo';
            source?: string | null;
            url?: string | null;
            type: OfflineContentType;
            options: {
              __typename?: 'VideoOptions';
              autoplay?: boolean | null;
              loop?: boolean | null;
            };
          }
        | null;
    } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  } | null;
};

export type SaveRoleIdentifierMutationVariables = Exact<{
  input: RoleIdentifierInput;
}>;

export type SaveRoleIdentifierMutation = {
  __typename?: 'Mutation';
  saveRoleIdentifier: {
    __typename?: 'SaveRoleIdentifierPayload';
    roleIdentifier?: { __typename?: 'RoleIdentifier'; id: string } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type SaveReportingConfigMutationVariables = Exact<{
  input: ReportingConfigInput;
}>;

export type SaveReportingConfigMutation = {
  __typename?: 'Mutation';
  saveReportingConfig: {
    __typename?: 'SaveReportingConfigPayload';
    reportingConfig: {
      __typename?: 'ReportingConfig';
      id: string;
      organizationId: string;
      transcriptsEnabled: boolean;
      serviceReportRecipients?: Array<string> | null;
    };
    errors: Array<{ __typename?: 'Error'; code: string } | null>;
  };
};

export type SaveServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ServiceInput;
  applyTo: ApplyEnum;
}>;

export type SaveServiceMutation = {
  __typename?: 'Mutation';
  saveService: {
    __typename?: 'SaveServicePayload';
    services: Array<{ __typename?: 'Service'; id?: string | null }>;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type MomentScheduleItemFieldsFragment = {
  __typename?: 'MomentScheduleItem';
  id: string;
  startTimeOffset?: number | null;
  ordinal?: number | null;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
};

export type LoadServiceFieldsFragment = {
  __typename?: 'Service';
  id?: string | null;
  scheduleTime?: any | null;
  weekOfMonth?: number | null;
  dayOfWeek?: string | null;
  dayOfMonth?: number | null;
  monthOfYear?: number | null;
  recurrence: RecurrenceEnum;
  endRepeat?: any | null;
  endTime?: any | null;
  versions: Array<{
    __typename?: 'Version';
    id: string;
    changes?: any | null;
    createdAt: any;
    event: string;
    whodunnit?: string | null;
    itemType: VersionItemType;
    subscriber?: {
      __typename?: 'Subscriber';
      id: string;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  }>;
  content?: {
    __typename?: 'Content';
    id: string;
    title: string;
    duration?: number | null;
    chatStartOffset?: number | null;
    chatEndOffset?: number | null;
    videoStartOffset?: number | null;
    notes?: string | null;
    hostInfo?: string | null;
    features?: {
      __typename?: 'ContentFeatures';
      publicChat?: boolean | null;
      livePrayer?: boolean | null;
    } | null;
    video?: { __typename?: 'Video'; id: string; type: VideoType; source: string } | null;
    momentScheduleItems: Array<{
      __typename?: 'MomentScheduleItem';
      id: string;
      startTimeOffset?: number | null;
      ordinal?: number | null;
      momentTemplate:
        | {
            __typename: 'ConnectMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'ConnectMomentOptions';
              text: string;
              windowType: WindowType;
              connectUrl: string;
            };
          }
        | {
            __typename: 'GivingMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'GivingMomentOptions';
              text: string;
              src: string;
              windowType: WindowType;
            };
          }
        | {
            __typename: 'ImageMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'ImageMomentOptions';
              altText?: string | null;
              imageUrl: string;
              shareText?: string | null;
            };
          }
        | {
            __typename: 'InviteMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
          }
        | {
            __typename: 'NextStepsMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'NextStepsMomentOptions';
              buttonText: string;
              description: string;
              iconUrl?: string | null;
              leadInText?: string | null;
              text: string;
              url?: string | null;
            };
          }
        | {
            __typename: 'PrayerMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
          }
        | {
            __typename: 'QuoteMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'QuoteMomentOptions';
              text: string;
              attribution?: string | null;
            };
          }
        | {
            __typename: 'ResponseMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'ResponseMomentOptions';
              text: string;
              buttonText: string;
              symbol: {
                __typename?: 'Symbol';
                id: string;
                name: string;
                native: string;
                unified: string;
              };
            };
          }
        | {
            __typename: 'SalvationMoment';
            id: string;
            type: MomentType;
            includedInFutureServices: boolean;
            updatedAt: any;
            options: {
              __typename?: 'SalvationMomentOptions';
              salvationMomentFollowUpType: SalvationMomentFollowUpType;
              url?: string | null;
              labels?: {
                __typename?: 'SalvationMomentLabels';
                prompt?: string | null;
                response?: string | null;
                buttonText?: string | null;
                celebrationMessage?: string | null;
              } | null;
            };
          };
    }>;
    versions: Array<{
      __typename?: 'Version';
      id: string;
      changes?: any | null;
      createdAt: any;
      event: string;
      whodunnit?: string | null;
      itemType: VersionItemType;
      subscriber?: {
        __typename?: 'Subscriber';
        id: string;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }>;
  } | null;
};

export type LoadServiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LoadServiceQuery = {
  __typename?: 'Query';
  loadService?: {
    __typename?: 'Service';
    id?: string | null;
    scheduleTime?: any | null;
    weekOfMonth?: number | null;
    dayOfWeek?: string | null;
    dayOfMonth?: number | null;
    monthOfYear?: number | null;
    recurrence: RecurrenceEnum;
    endRepeat?: any | null;
    endTime?: any | null;
    versions: Array<{
      __typename?: 'Version';
      id: string;
      changes?: any | null;
      createdAt: any;
      event: string;
      whodunnit?: string | null;
      itemType: VersionItemType;
      subscriber?: {
        __typename?: 'Subscriber';
        id: string;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }>;
    content?: {
      __typename?: 'Content';
      id: string;
      title: string;
      duration?: number | null;
      chatStartOffset?: number | null;
      chatEndOffset?: number | null;
      videoStartOffset?: number | null;
      notes?: string | null;
      hostInfo?: string | null;
      features?: {
        __typename?: 'ContentFeatures';
        publicChat?: boolean | null;
        livePrayer?: boolean | null;
      } | null;
      video?: { __typename?: 'Video'; id: string; type: VideoType; source: string } | null;
      momentScheduleItems: Array<{
        __typename?: 'MomentScheduleItem';
        id: string;
        startTimeOffset?: number | null;
        ordinal?: number | null;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
      }>;
      versions: Array<{
        __typename?: 'Version';
        id: string;
        changes?: any | null;
        createdAt: any;
        event: string;
        whodunnit?: string | null;
        itemType: VersionItemType;
        subscriber?: {
          __typename?: 'Subscriber';
          id: string;
          email?: string | null;
          firstName?: string | null;
          lastName?: string | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type MomentInstanceMetricFieldsFragment = {
  __typename?: 'MomentInstanceMetric';
  momentInstanceId: string;
  impressions: number;
  interactions: number;
  submissions: number;
  likes: number;
  shares: number;
};

export type MomentInstanceFields_ConnectMomentInstance_Fragment = {
  __typename?: 'ConnectMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_GivingMomentInstance_Fragment = {
  __typename?: 'GivingMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_ImageMomentInstance_Fragment = {
  __typename?: 'ImageMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_InviteMomentInstance_Fragment = {
  __typename?: 'InviteMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_NextStepsMomentInstance_Fragment = {
  __typename?: 'NextStepsMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_PrayerMomentInstance_Fragment = {
  __typename?: 'PrayerMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_QuoteMomentInstance_Fragment = {
  __typename?: 'QuoteMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_ResponseMomentInstance_Fragment = {
  __typename?: 'ResponseMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFields_SalvationMomentInstance_Fragment = {
  __typename?: 'SalvationMomentInstance';
  id: string;
  postTime: any;
  deleted: boolean;
  momentTemplate:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      };
  metrics: Array<{
    __typename?: 'MomentInstanceMetric';
    momentInstanceId: string;
    impressions: number;
    interactions: number;
    submissions: number;
    likes: number;
    shares: number;
  }>;
};

export type MomentInstanceFieldsFragment =
  | MomentInstanceFields_ConnectMomentInstance_Fragment
  | MomentInstanceFields_GivingMomentInstance_Fragment
  | MomentInstanceFields_ImageMomentInstance_Fragment
  | MomentInstanceFields_InviteMomentInstance_Fragment
  | MomentInstanceFields_NextStepsMomentInstance_Fragment
  | MomentInstanceFields_PrayerMomentInstance_Fragment
  | MomentInstanceFields_QuoteMomentInstance_Fragment
  | MomentInstanceFields_ResponseMomentInstance_Fragment
  | MomentInstanceFields_SalvationMomentInstance_Fragment;

export type ServiceMetricFieldsFragment = {
  __typename?: 'Service';
  id?: string | null;
  startTime?: any | null;
  scheduleTime?: any | null;
  endTime?: any | null;
  content?: { __typename?: 'Content'; id: string; title: string } | null;
  metrics: Array<{
    __typename: 'ServiceMetric';
    serviceId: string;
    salvations: number;
    msgsPublicByHosts: number;
    msgsPublic: number;
    msgsPrayer: number;
    msgsHost: number;
    msgsDirect: number;
    chattersHosts: number;
    chattersAttenders: number;
    totalTimeWatchedSecs: number;
    avgTimeWatched: number;
    viewers0s: number;
    viewers3s: number;
    viewers10s: number;
    viewers30s: number;
    viewers60s: number;
    viewers5m: number;
    viewers10m: number;
    viewers15m: number;
    viewers20m: number;
    viewers25m: number;
    viewers30m: number;
    hostsPresent: number;
    timelineSubsPresentT: string;
    timelineSubsPresentC: string;
    timelinePrayerT?: string | null;
    timelinePrayerC?: string | null;
  }>;
  momentInstances: Array<
    | {
        __typename?: 'ConnectMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'GivingMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'ImageMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'InviteMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'NextStepsMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'PrayerMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'QuoteMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'ResponseMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
    | {
        __typename?: 'SalvationMomentInstance';
        id: string;
        postTime: any;
        deleted: boolean;
        momentTemplate:
          | {
              __typename: 'ConnectMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ConnectMomentOptions';
                text: string;
                windowType: WindowType;
                connectUrl: string;
              };
            }
          | {
              __typename: 'GivingMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'GivingMomentOptions';
                text: string;
                src: string;
                windowType: WindowType;
              };
            }
          | {
              __typename: 'ImageMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ImageMomentOptions';
                altText?: string | null;
                imageUrl: string;
                shareText?: string | null;
              };
            }
          | {
              __typename: 'InviteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'NextStepsMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'NextStepsMomentOptions';
                buttonText: string;
                description: string;
                iconUrl?: string | null;
                leadInText?: string | null;
                text: string;
                url?: string | null;
              };
            }
          | {
              __typename: 'PrayerMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
            }
          | {
              __typename: 'QuoteMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'QuoteMomentOptions';
                text: string;
                attribution?: string | null;
              };
            }
          | {
              __typename: 'ResponseMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'ResponseMomentOptions';
                text: string;
                buttonText: string;
                symbol: {
                  __typename?: 'Symbol';
                  id: string;
                  name: string;
                  native: string;
                  unified: string;
                };
              };
            }
          | {
              __typename: 'SalvationMoment';
              id: string;
              type: MomentType;
              includedInFutureServices: boolean;
              updatedAt: any;
              options: {
                __typename?: 'SalvationMomentOptions';
                salvationMomentFollowUpType: SalvationMomentFollowUpType;
                url?: string | null;
                labels?: {
                  __typename?: 'SalvationMomentLabels';
                  prompt?: string | null;
                  response?: string | null;
                  buttonText?: string | null;
                  celebrationMessage?: string | null;
                } | null;
              };
            };
        metrics: Array<{
          __typename?: 'MomentInstanceMetric';
          momentInstanceId: string;
          impressions: number;
          interactions: number;
          submissions: number;
          likes: number;
          shares: number;
        }>;
      }
  >;
};

export type LoadServiceMetricsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LoadServiceMetricsQuery = {
  __typename?: 'Query';
  loadService?: {
    __typename?: 'Service';
    id?: string | null;
    startTime?: any | null;
    scheduleTime?: any | null;
    endTime?: any | null;
    content?: { __typename?: 'Content'; id: string; title: string } | null;
    metrics: Array<{
      __typename: 'ServiceMetric';
      serviceId: string;
      salvations: number;
      msgsPublicByHosts: number;
      msgsPublic: number;
      msgsPrayer: number;
      msgsHost: number;
      msgsDirect: number;
      chattersHosts: number;
      chattersAttenders: number;
      totalTimeWatchedSecs: number;
      avgTimeWatched: number;
      viewers0s: number;
      viewers3s: number;
      viewers10s: number;
      viewers30s: number;
      viewers60s: number;
      viewers5m: number;
      viewers10m: number;
      viewers15m: number;
      viewers20m: number;
      viewers25m: number;
      viewers30m: number;
      hostsPresent: number;
      timelineSubsPresentT: string;
      timelineSubsPresentC: string;
      timelinePrayerT?: string | null;
      timelinePrayerC?: string | null;
    }>;
    momentInstances: Array<
      | {
          __typename?: 'ConnectMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'GivingMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'ImageMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'InviteMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'NextStepsMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'PrayerMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'QuoteMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'ResponseMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
      | {
          __typename?: 'SalvationMomentInstance';
          id: string;
          postTime: any;
          deleted: boolean;
          momentTemplate:
            | {
                __typename: 'ConnectMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ConnectMomentOptions';
                  text: string;
                  windowType: WindowType;
                  connectUrl: string;
                };
              }
            | {
                __typename: 'GivingMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'GivingMomentOptions';
                  text: string;
                  src: string;
                  windowType: WindowType;
                };
              }
            | {
                __typename: 'ImageMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ImageMomentOptions';
                  altText?: string | null;
                  imageUrl: string;
                  shareText?: string | null;
                };
              }
            | {
                __typename: 'InviteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'NextStepsMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'NextStepsMomentOptions';
                  buttonText: string;
                  description: string;
                  iconUrl?: string | null;
                  leadInText?: string | null;
                  text: string;
                  url?: string | null;
                };
              }
            | {
                __typename: 'PrayerMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
              }
            | {
                __typename: 'QuoteMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'QuoteMomentOptions';
                  text: string;
                  attribution?: string | null;
                };
              }
            | {
                __typename: 'ResponseMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'ResponseMomentOptions';
                  text: string;
                  buttonText: string;
                  symbol: {
                    __typename?: 'Symbol';
                    id: string;
                    name: string;
                    native: string;
                    unified: string;
                  };
                };
              }
            | {
                __typename: 'SalvationMoment';
                id: string;
                type: MomentType;
                includedInFutureServices: boolean;
                updatedAt: any;
                options: {
                  __typename?: 'SalvationMomentOptions';
                  salvationMomentFollowUpType: SalvationMomentFollowUpType;
                  url?: string | null;
                  labels?: {
                    __typename?: 'SalvationMomentLabels';
                    prompt?: string | null;
                    response?: string | null;
                    buttonText?: string | null;
                    celebrationMessage?: string | null;
                  } | null;
                };
              };
          metrics: Array<{
            __typename?: 'MomentInstanceMetric';
            momentInstanceId: string;
            impressions: number;
            interactions: number;
            submissions: number;
            likes: number;
            shares: number;
          }>;
        }
    >;
  } | null;
};

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  applyTo: ApplyEnum;
}>;

export type DeleteServiceMutation = {
  __typename?: 'Mutation';
  deleteService: {
    __typename?: 'DeleteServicePayload';
    service?: { __typename?: 'Service'; id?: string | null } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type ServiceFieldsFragment = {
  __typename?: 'Service';
  id?: string | null;
  scheduleTime?: any | null;
  startTime?: any | null;
  endTime?: any | null;
  recurrence: RecurrenceEnum;
  endRepeat?: any | null;
  content?: {
    __typename?: 'Content';
    id: string;
    title: string;
    video?: { __typename?: 'Video'; id: string; source: string } | null;
  } | null;
};

export type ServicesConnectionOrganizationFieldsFragment = {
  __typename?: 'Organization';
  servicesConnection: {
    __typename?: 'ServicesConnection';
    aggregate: { __typename?: 'Aggregate'; count: number; from: any; to: any };
    services: Array<{
      __typename?: 'Service';
      id?: string | null;
      scheduleTime?: any | null;
      startTime?: any | null;
      endTime?: any | null;
      recurrence: RecurrenceEnum;
      endRepeat?: any | null;
      content?: {
        __typename?: 'Content';
        id: string;
        title: string;
        video?: { __typename?: 'Video'; id: string; source: string } | null;
      } | null;
    }>;
  };
};

export type AdminServicesConnectionQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  expandToContentId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<OrderType>;
  filter?: InputMaybe<ServicesConnectionFilter>;
}>;

export type AdminServicesConnectionQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    servicesConnection: {
      __typename?: 'ServicesConnection';
      aggregate: { __typename?: 'Aggregate'; count: number; from: any; to: any };
      services: Array<{
        __typename?: 'Service';
        id?: string | null;
        scheduleTime?: any | null;
        startTime?: any | null;
        endTime?: any | null;
        recurrence: RecurrenceEnum;
        endRepeat?: any | null;
        content?: {
          __typename?: 'Content';
          id: string;
          title: string;
          video?: { __typename?: 'Video'; id: string; source: string } | null;
        } | null;
      }>;
    };
  } | null;
};

export type ActiveMetricFieldsFragment = {
  __typename: 'AnalyticsOverviewMetric';
  accountsCreated: number;
  avgPrayerMessages: number;
  avgTimeAttended: number;
  offlineRequests: number;
  prayerRequesters: number;
  prayerRequests: number;
  prayerSessions: number;
  salvations: number;
  timepoint: any;
  totalTimeAttended: number;
  uniqueAttenders: number;
  uniqueAttendersPreviousYear: number;
  uniqueHosts: number;
};

export type ComparisonMetricFieldsFragment = {
  __typename: 'AnalyticsOverviewMetric';
  accountsCreated: number;
  avgPrayerMessages: number;
  offlineRequests: number;
  prayerRequesters: number;
  prayerRequests: number;
  prayerSessions: number;
  timepoint: any;
  uniqueAttenders: number;
  uniqueHosts: number;
};

export type AnalyticsOverviewFieldsFragment = {
  __typename?: 'AnalyticsOverviewMetrics';
  groupingUnit: GroupingUnitType;
  activeMetrics: Array<{
    __typename: 'AnalyticsOverviewMetric';
    accountsCreated: number;
    avgPrayerMessages: number;
    avgTimeAttended: number;
    offlineRequests: number;
    prayerRequesters: number;
    prayerRequests: number;
    prayerSessions: number;
    salvations: number;
    timepoint: any;
    totalTimeAttended: number;
    uniqueAttenders: number;
    uniqueAttendersPreviousYear: number;
    uniqueHosts: number;
  }>;
  comparisonMetrics: Array<{
    __typename: 'AnalyticsOverviewMetric';
    accountsCreated: number;
    avgPrayerMessages: number;
    offlineRequests: number;
    prayerRequesters: number;
    prayerRequests: number;
    prayerSessions: number;
    timepoint: any;
    uniqueAttenders: number;
    uniqueHosts: number;
  }>;
};

export type ServicesConnectionFieldsFragment = {
  __typename?: 'ServicesConnection';
  aggregate: { __typename?: 'Aggregate'; count: number; from: any; to: any };
  services: Array<{
    __typename?: 'Service';
    id?: string | null;
    scheduleTime?: any | null;
    startTime?: any | null;
    endTime?: any | null;
    recurrence: RecurrenceEnum;
    metrics: Array<{ __typename?: 'ServiceMetric'; serviceId: string; viewers0s: number }>;
  }>;
};

export type AdminOverviewConnectionOrganizationFieldsFragment = {
  __typename?: 'Organization';
  analyticsOverview: {
    __typename?: 'AnalyticsOverviewMetrics';
    groupingUnit: GroupingUnitType;
    activeMetrics: Array<{
      __typename: 'AnalyticsOverviewMetric';
      accountsCreated: number;
      avgPrayerMessages: number;
      avgTimeAttended: number;
      offlineRequests: number;
      prayerRequesters: number;
      prayerRequests: number;
      prayerSessions: number;
      salvations: number;
      timepoint: any;
      totalTimeAttended: number;
      uniqueAttenders: number;
      uniqueAttendersPreviousYear: number;
      uniqueHosts: number;
    }>;
    comparisonMetrics: Array<{
      __typename: 'AnalyticsOverviewMetric';
      accountsCreated: number;
      avgPrayerMessages: number;
      offlineRequests: number;
      prayerRequesters: number;
      prayerRequests: number;
      prayerSessions: number;
      timepoint: any;
      uniqueAttenders: number;
      uniqueHosts: number;
    }>;
  };
  servicesConnection: {
    __typename?: 'ServicesConnection';
    aggregate: { __typename?: 'Aggregate'; count: number; from: any; to: any };
    services: Array<{
      __typename?: 'Service';
      id?: string | null;
      scheduleTime?: any | null;
      startTime?: any | null;
      endTime?: any | null;
      recurrence: RecurrenceEnum;
      metrics: Array<{ __typename?: 'ServiceMetric'; serviceId: string; viewers0s: number }>;
    }>;
  };
};

export type AdminOverviewConnectionQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  expandToContentId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ServicesConnectionFilter>;
}>;

export type AdminOverviewConnectionQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    analyticsOverview: {
      __typename?: 'AnalyticsOverviewMetrics';
      groupingUnit: GroupingUnitType;
      activeMetrics: Array<{
        __typename: 'AnalyticsOverviewMetric';
        accountsCreated: number;
        avgPrayerMessages: number;
        avgTimeAttended: number;
        offlineRequests: number;
        prayerRequesters: number;
        prayerRequests: number;
        prayerSessions: number;
        salvations: number;
        timepoint: any;
        totalTimeAttended: number;
        uniqueAttenders: number;
        uniqueAttendersPreviousYear: number;
        uniqueHosts: number;
      }>;
      comparisonMetrics: Array<{
        __typename: 'AnalyticsOverviewMetric';
        accountsCreated: number;
        avgPrayerMessages: number;
        offlineRequests: number;
        prayerRequesters: number;
        prayerRequests: number;
        prayerSessions: number;
        timepoint: any;
        uniqueAttenders: number;
        uniqueHosts: number;
      }>;
    };
    servicesConnection: {
      __typename?: 'ServicesConnection';
      aggregate: { __typename?: 'Aggregate'; count: number; from: any; to: any };
      services: Array<{
        __typename?: 'Service';
        id?: string | null;
        scheduleTime?: any | null;
        startTime?: any | null;
        endTime?: any | null;
        recurrence: RecurrenceEnum;
        metrics: Array<{ __typename?: 'ServiceMetric'; serviceId: string; viewers0s: number }>;
      }>;
    };
  } | null;
};

export type SaveContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ContentInput;
}>;

export type SaveContentMutation = {
  __typename?: 'Mutation';
  saveContent: {
    __typename?: 'SaveContentPayload';
    content?: { __typename?: 'Content'; id: string } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type RemoveContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  services: Array<ServiceInput> | ServiceInput;
}>;

export type RemoveContentMutation = {
  __typename?: 'Mutation';
  removeContent: {
    __typename?: 'RemoveContentPayload';
    content?: { __typename?: 'Content'; id: string } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  };
};

export type SubscribersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<SubscriberSortOrder> | SubscriberSortOrder>;
  filter?: InputMaybe<SubscribersFilter>;
}>;

export type SubscribersQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    subscribers: {
      __typename?: 'SubscriberConnection';
      totalCount: number;
      edges?: Array<{
        __typename?: 'SubscriberEdge';
        node?: {
          __typename?: 'Subscriber';
          id: string;
          nickname?: string | null;
          avatar?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          muted: boolean;
          mutedUntil?: any | null;
          lastActivity?: any | null;
          emailConsent?: boolean | null;
          createdAt?: any | null;
          inviteExpiresAt?: any | null;
          invitePending: boolean;
          roleIdentifier?: {
            __typename?: 'RoleIdentifier';
            id: string;
            key: string;
            type: RoleIdentifierType;
            label?: string | null;
          } | null;
          role?: {
            __typename?: 'Role';
            id: string;
            name: string;
            label: string;
            type: RoleType;
          } | null;
        } | null;
      } | null> | null;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    };
  } | null;
};

export type SaveMomentScheduleMutationVariables = Exact<{
  contentId: Scalars['ID']['input'];
  input: Array<MomentScheduleItemInput> | MomentScheduleItemInput;
}>;

export type SaveMomentScheduleMutation = {
  __typename?: 'Mutation';
  saveMomentSchedule: {
    __typename?: 'SaveMomentSchedulePayload';
    errors: Array<{ __typename?: 'Error'; code: string; property?: string | null }>;
  };
};

export type MomentTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type MomentTemplatesQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    momentTemplates: Array<
      | {
          __typename: 'ConnectMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ConnectMomentOptions';
            text: string;
            windowType: WindowType;
            connectUrl: string;
          };
        }
      | {
          __typename: 'GivingMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'GivingMomentOptions';
            text: string;
            src: string;
            windowType: WindowType;
          };
        }
      | {
          __typename: 'ImageMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ImageMomentOptions';
            altText?: string | null;
            imageUrl: string;
            shareText?: string | null;
          };
        }
      | {
          __typename: 'InviteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'NextStepsMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'NextStepsMomentOptions';
            buttonText: string;
            description: string;
            iconUrl?: string | null;
            leadInText?: string | null;
            text: string;
            url?: string | null;
          };
        }
      | {
          __typename: 'PrayerMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'QuoteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
        }
      | {
          __typename: 'ResponseMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ResponseMomentOptions';
            text: string;
            buttonText: string;
            symbol: {
              __typename?: 'Symbol';
              id: string;
              name: string;
              native: string;
              unified: string;
            };
          };
        }
      | {
          __typename: 'SalvationMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'SalvationMomentOptions';
            salvationMomentFollowUpType: SalvationMomentFollowUpType;
            url?: string | null;
            labels?: {
              __typename?: 'SalvationMomentLabels';
              prompt?: string | null;
              response?: string | null;
              buttonText?: string | null;
              celebrationMessage?: string | null;
            } | null;
          };
        }
    >;
  } | null;
};

export type MomentTemplateQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type MomentTemplateQueryQuery = {
  __typename?: 'Query';
  momentTemplate?:
    | {
        __typename: 'ConnectMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ConnectMomentOptions';
          text: string;
          windowType: WindowType;
          connectUrl: string;
        };
      }
    | {
        __typename: 'GivingMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'GivingMomentOptions';
          text: string;
          src: string;
          windowType: WindowType;
        };
      }
    | {
        __typename: 'ImageMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ImageMomentOptions';
          altText?: string | null;
          imageUrl: string;
          shareText?: string | null;
        };
      }
    | {
        __typename: 'InviteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'NextStepsMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'NextStepsMomentOptions';
          buttonText: string;
          description: string;
          iconUrl?: string | null;
          leadInText?: string | null;
          text: string;
          url?: string | null;
        };
      }
    | {
        __typename: 'PrayerMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
      }
    | {
        __typename: 'QuoteMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
      }
    | {
        __typename: 'ResponseMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'ResponseMomentOptions';
          text: string;
          buttonText: string;
          symbol: {
            __typename?: 'Symbol';
            id: string;
            name: string;
            native: string;
            unified: string;
          };
        };
      }
    | {
        __typename: 'SalvationMoment';
        id: string;
        type: MomentType;
        includedInFutureServices: boolean;
        updatedAt: any;
        options: {
          __typename?: 'SalvationMomentOptions';
          salvationMomentFollowUpType: SalvationMomentFollowUpType;
          url?: string | null;
          labels?: {
            __typename?: 'SalvationMomentLabels';
            prompt?: string | null;
            response?: string | null;
            buttonText?: string | null;
            celebrationMessage?: string | null;
          } | null;
        };
      }
    | null;
};

export type NextStepsTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type NextStepsTemplatesQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    nextStepsTemplates: Array<
      | {
          __typename: 'ConnectMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ConnectMomentOptions';
            text: string;
            windowType: WindowType;
            connectUrl: string;
          };
        }
      | {
          __typename: 'GivingMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'GivingMomentOptions';
            text: string;
            src: string;
            windowType: WindowType;
          };
        }
      | {
          __typename: 'ImageMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ImageMomentOptions';
            altText?: string | null;
            imageUrl: string;
            shareText?: string | null;
          };
        }
      | {
          __typename: 'InviteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'NextStepsMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'NextStepsMomentOptions';
            buttonText: string;
            description: string;
            iconUrl?: string | null;
            leadInText?: string | null;
            text: string;
            url?: string | null;
          };
        }
      | {
          __typename: 'PrayerMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'QuoteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
        }
      | {
          __typename: 'ResponseMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ResponseMomentOptions';
            text: string;
            buttonText: string;
            symbol: {
              __typename?: 'Symbol';
              id: string;
              name: string;
              native: string;
              unified: string;
            };
          };
        }
      | {
          __typename: 'SalvationMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'SalvationMomentOptions';
            salvationMomentFollowUpType: SalvationMomentFollowUpType;
            url?: string | null;
            labels?: {
              __typename?: 'SalvationMomentLabels';
              prompt?: string | null;
              response?: string | null;
              buttonText?: string | null;
              celebrationMessage?: string | null;
            } | null;
          };
        }
    >;
  } | null;
};

export type ExportUsersMutationVariables = Exact<{ [key: string]: never }>;

export type ExportUsersMutation = {
  __typename?: 'Mutation';
  exportUsers: { __typename?: 'ExportUsersPayload'; downloadUrl?: string | null };
};

export type LoadLastVideoEmbedQueryVariables = Exact<{ [key: string]: never }>;

export type LoadLastVideoEmbedQuery = { __typename?: 'Query'; loadLastVideoEmbed?: string | null };

export type SetupSharingQueryVariables = Exact<{ [key: string]: never }>;

export type SetupSharingQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    shareImage?: string | null;
    shareDescription?: string | null;
  } | null;
};

export type OnboardingStepFieldsFragment = {
  __typename?: 'OnboardingStep';
  id: string;
  key: string;
  ordinal: number;
  skipped: boolean;
  completed: boolean;
};

export type CurrentOrganizationOnboardingQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentOrganizationOnboardingQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    id: string;
    name: string;
    onboardingSteps?: Array<{
      __typename?: 'OnboardingStep';
      id: string;
      key: string;
      ordinal: number;
      skipped: boolean;
      completed: boolean;
    }> | null;
  } | null;
};

export type SaveOnboardingStepMutationVariables = Exact<{
  input: OnboardingStepInput;
}>;

export type SaveOnboardingStepMutation = {
  __typename?: 'Mutation';
  saveOnboardingStep?: {
    __typename?: 'SaveOnboardingStepPayload';
    onboardingStep?: {
      __typename?: 'OnboardingStep';
      id: string;
      key: string;
      ordinal: number;
      skipped: boolean;
      completed: boolean;
    } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      message?: string | null;
      property?: string | null;
    }>;
  } | null;
};

export type SavePreviewServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SavePreviewServiceMutation = {
  __typename?: 'Mutation';
  savePreviewService?: {
    __typename?: 'SavePreviewServicePayload';
    job?: {
      __typename?: 'PreviewServiceJob';
      id: string;
      updateTime: any;
      at?: number | null;
      total?: number | null;
      message?: string | null;
      percentComplete?: number | null;
      status: JobStatus;
      meta?: { __typename?: 'PreviewServiceJobMeta'; serviceId?: string | null } | null;
    } | null;
    errors: Array<{ __typename?: 'Error'; code: string; message?: string | null }>;
  } | null;
};

export type EventJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;

export type EventJobQuery = {
  __typename?: 'Query';
  eventJob?: {
    __typename?: 'PreviewServiceJob';
    id: string;
    at?: number | null;
    message?: string | null;
    percentComplete?: number | null;
    status: JobStatus;
    total?: number | null;
    updateTime: any;
    meta?: { __typename?: 'PreviewServiceJobMeta'; serviceId?: string | null } | null;
  } | null;
};

export type WebhookFieldsFragment = {
  __typename?: 'Webhook';
  id: string;
  url: string;
  events: Array<WebhookEventType>;
  active: boolean;
  secretKey: string;
  updatedAt: any;
  anonymousEvents: boolean;
};

export type IntegrationFields_FacebookApp_Fragment = {
  __typename: 'FacebookApp';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'FacebookAppConfig'; appId: string; appSecret?: string | null };
};

export type IntegrationFields_FacebookPixel_Fragment = {
  __typename: 'FacebookPixel';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'FacebookPixelConfig'; pixelId: string };
};

export type IntegrationFields_Front_Fragment = {
  __typename: 'Front';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'FrontConfig'; frontId?: string | null };
};

export type IntegrationFields_Gloo_Fragment = {
  __typename: 'Gloo';
  id: string;
  type: IntegrationType;
  enabled: boolean;
};

export type IntegrationFields_GoogleAnalytics_Fragment = {
  __typename: 'GoogleAnalytics';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'GoogleAnalyticsConfig'; trackingId: string };
};

export type IntegrationFields_GoogleAnalytics4_Fragment = {
  __typename: 'GoogleAnalytics4';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'GoogleAnalytics4Config'; trackingId: string };
};

export type IntegrationFields_GoogleSheets_Fragment = {
  __typename: 'GoogleSheets';
  id: string;
  type: IntegrationType;
  enabled: boolean;
};

export type IntegrationFields_GoogleTagManager_Fragment = {
  __typename: 'GoogleTagManager';
  id: string;
  type: IntegrationType;
  enabled: boolean;
};

export type IntegrationFields_HubSpot_Fragment = {
  __typename: 'HubSpot';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'HubSpotConfig'; trackingCodeId: string };
};

export type IntegrationFields_LegacyAuth_Fragment = {
  __typename: 'LegacyAuth';
  id: string;
  type: IntegrationType;
  enabled: boolean;
};

export type IntegrationFields_OpenIdConnect_Fragment = {
  __typename: 'OpenIdConnect';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: {
    __typename?: 'OpenIdConnectConfig';
    issuerUri: string;
    clientId: string;
    clientSecret?: string | null;
  };
};

export type IntegrationFields_Osano_Fragment = {
  __typename: 'Osano';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: { __typename?: 'OsanoConfig'; accountId: string; configId: string };
};

export type IntegrationFields_Segment_Fragment = {
  __typename: 'Segment';
  id: string;
  type: IntegrationType;
  enabled: boolean;
};

export type IntegrationFields_StackAdapt_Fragment = {
  __typename: 'StackAdapt';
  id: string;
  type: IntegrationType;
  enabled: boolean;
};

export type IntegrationFields_WebhooksIntegration_Fragment = {
  __typename: 'WebhooksIntegration';
  id: string;
  type: IntegrationType;
  enabled: boolean;
  config: {
    __typename?: 'WebhooksConfig';
    webhooks: Array<{
      __typename?: 'Webhook';
      id: string;
      url: string;
      events: Array<WebhookEventType>;
      active: boolean;
      secretKey: string;
      updatedAt: any;
      anonymousEvents: boolean;
    }>;
  };
};

export type IntegrationFieldsFragment =
  | IntegrationFields_FacebookApp_Fragment
  | IntegrationFields_FacebookPixel_Fragment
  | IntegrationFields_Front_Fragment
  | IntegrationFields_Gloo_Fragment
  | IntegrationFields_GoogleAnalytics_Fragment
  | IntegrationFields_GoogleAnalytics4_Fragment
  | IntegrationFields_GoogleSheets_Fragment
  | IntegrationFields_GoogleTagManager_Fragment
  | IntegrationFields_HubSpot_Fragment
  | IntegrationFields_LegacyAuth_Fragment
  | IntegrationFields_OpenIdConnect_Fragment
  | IntegrationFields_Osano_Fragment
  | IntegrationFields_Segment_Fragment
  | IntegrationFields_StackAdapt_Fragment
  | IntegrationFields_WebhooksIntegration_Fragment;

export type LoadIntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LoadIntegrationQuery = {
  __typename?: 'Query';
  loadIntegration?:
    | {
        __typename: 'FacebookApp';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'FacebookAppConfig'; appId: string; appSecret?: string | null };
      }
    | {
        __typename: 'FacebookPixel';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'FacebookPixelConfig'; pixelId: string };
      }
    | {
        __typename: 'Front';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'FrontConfig'; frontId?: string | null };
      }
    | { __typename: 'Gloo'; id: string; type: IntegrationType; enabled: boolean }
    | {
        __typename: 'GoogleAnalytics';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'GoogleAnalyticsConfig'; trackingId: string };
      }
    | {
        __typename: 'GoogleAnalytics4';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'GoogleAnalytics4Config'; trackingId: string };
      }
    | { __typename: 'GoogleSheets'; id: string; type: IntegrationType; enabled: boolean }
    | { __typename: 'GoogleTagManager'; id: string; type: IntegrationType; enabled: boolean }
    | {
        __typename: 'HubSpot';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'HubSpotConfig'; trackingCodeId: string };
      }
    | { __typename: 'LegacyAuth'; id: string; type: IntegrationType; enabled: boolean }
    | {
        __typename: 'OpenIdConnect';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: {
          __typename?: 'OpenIdConnectConfig';
          issuerUri: string;
          clientId: string;
          clientSecret?: string | null;
        };
      }
    | {
        __typename: 'Osano';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: { __typename?: 'OsanoConfig'; accountId: string; configId: string };
      }
    | { __typename: 'Segment'; id: string; type: IntegrationType; enabled: boolean }
    | { __typename: 'StackAdapt'; id: string; type: IntegrationType; enabled: boolean }
    | {
        __typename: 'WebhooksIntegration';
        id: string;
        type: IntegrationType;
        enabled: boolean;
        config: {
          __typename?: 'WebhooksConfig';
          webhooks: Array<{
            __typename?: 'Webhook';
            id: string;
            url: string;
            events: Array<WebhookEventType>;
            active: boolean;
            secretKey: string;
            updatedAt: any;
            anonymousEvents: boolean;
          }>;
        };
      }
    | null;
};

export type IntegrationsForCurrentOrganizationQueryVariables = Exact<{
  filter?: InputMaybe<IntegrationSearchFilter>;
}>;

export type IntegrationsForCurrentOrganizationQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    integrations: Array<
      | {
          __typename: 'FacebookApp';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FacebookAppConfig'; appId: string; appSecret?: string | null };
        }
      | {
          __typename: 'FacebookPixel';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FacebookPixelConfig'; pixelId: string };
        }
      | {
          __typename: 'Front';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FrontConfig'; frontId?: string | null };
        }
      | { __typename: 'Gloo'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'GoogleAnalytics';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'GoogleAnalyticsConfig'; trackingId: string };
        }
      | {
          __typename: 'GoogleAnalytics4';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'GoogleAnalytics4Config'; trackingId: string };
        }
      | { __typename: 'GoogleSheets'; id: string; type: IntegrationType; enabled: boolean }
      | { __typename: 'GoogleTagManager'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'HubSpot';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'HubSpotConfig'; trackingCodeId: string };
        }
      | { __typename: 'LegacyAuth'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'OpenIdConnect';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: {
            __typename?: 'OpenIdConnectConfig';
            issuerUri: string;
            clientId: string;
            clientSecret?: string | null;
          };
        }
      | {
          __typename: 'Osano';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'OsanoConfig'; accountId: string; configId: string };
        }
      | { __typename: 'Segment'; id: string; type: IntegrationType; enabled: boolean }
      | { __typename: 'StackAdapt'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'WebhooksIntegration';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: {
            __typename?: 'WebhooksConfig';
            webhooks: Array<{
              __typename?: 'Webhook';
              id: string;
              url: string;
              events: Array<WebhookEventType>;
              active: boolean;
              secretKey: string;
              updatedAt: any;
              anonymousEvents: boolean;
            }>;
          };
        }
    >;
  } | null;
};

export type SaveIntegrationMutationVariables = Exact<{
  input: IntegrationInput;
}>;

export type SaveIntegrationMutation = {
  __typename?: 'Mutation';
  saveIntegration: {
    __typename?: 'SaveIntegrationPayload';
    integration?:
      | {
          __typename: 'FacebookApp';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FacebookAppConfig'; appId: string; appSecret?: string | null };
        }
      | {
          __typename: 'FacebookPixel';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FacebookPixelConfig'; pixelId: string };
        }
      | {
          __typename: 'Front';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FrontConfig'; frontId?: string | null };
        }
      | { __typename: 'Gloo'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'GoogleAnalytics';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'GoogleAnalyticsConfig'; trackingId: string };
        }
      | {
          __typename: 'GoogleAnalytics4';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'GoogleAnalytics4Config'; trackingId: string };
        }
      | { __typename: 'GoogleSheets'; id: string; type: IntegrationType; enabled: boolean }
      | { __typename: 'GoogleTagManager'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'HubSpot';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'HubSpotConfig'; trackingCodeId: string };
        }
      | { __typename: 'LegacyAuth'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'OpenIdConnect';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: {
            __typename?: 'OpenIdConnectConfig';
            issuerUri: string;
            clientId: string;
            clientSecret?: string | null;
          };
        }
      | {
          __typename: 'Osano';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'OsanoConfig'; accountId: string; configId: string };
        }
      | { __typename: 'Segment'; id: string; type: IntegrationType; enabled: boolean }
      | { __typename: 'StackAdapt'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'WebhooksIntegration';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: {
            __typename?: 'WebhooksConfig';
            webhooks: Array<{
              __typename?: 'Webhook';
              id: string;
              url: string;
              events: Array<WebhookEventType>;
              active: boolean;
              secretKey: string;
              updatedAt: any;
              anonymousEvents: boolean;
            }>;
          };
        }
      | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      property?: string | null;
      message?: string | null;
    }>;
  };
};

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteIntegrationMutation = {
  __typename?: 'Mutation';
  deleteIntegration: {
    __typename?: 'DeleteIntegrationPayload';
    integration?:
      | {
          __typename: 'FacebookApp';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FacebookAppConfig'; appId: string; appSecret?: string | null };
        }
      | {
          __typename: 'FacebookPixel';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FacebookPixelConfig'; pixelId: string };
        }
      | {
          __typename: 'Front';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'FrontConfig'; frontId?: string | null };
        }
      | { __typename: 'Gloo'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'GoogleAnalytics';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'GoogleAnalyticsConfig'; trackingId: string };
        }
      | {
          __typename: 'GoogleAnalytics4';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'GoogleAnalytics4Config'; trackingId: string };
        }
      | { __typename: 'GoogleSheets'; id: string; type: IntegrationType; enabled: boolean }
      | { __typename: 'GoogleTagManager'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'HubSpot';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'HubSpotConfig'; trackingCodeId: string };
        }
      | { __typename: 'LegacyAuth'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'OpenIdConnect';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: {
            __typename?: 'OpenIdConnectConfig';
            issuerUri: string;
            clientId: string;
            clientSecret?: string | null;
          };
        }
      | {
          __typename: 'Osano';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: { __typename?: 'OsanoConfig'; accountId: string; configId: string };
        }
      | { __typename: 'Segment'; id: string; type: IntegrationType; enabled: boolean }
      | { __typename: 'StackAdapt'; id: string; type: IntegrationType; enabled: boolean }
      | {
          __typename: 'WebhooksIntegration';
          id: string;
          type: IntegrationType;
          enabled: boolean;
          config: {
            __typename?: 'WebhooksConfig';
            webhooks: Array<{
              __typename?: 'Webhook';
              id: string;
              url: string;
              events: Array<WebhookEventType>;
              active: boolean;
              secretKey: string;
              updatedAt: any;
              anonymousEvents: boolean;
            }>;
          };
        }
      | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      property?: string | null;
      message?: string | null;
    }>;
  };
};

export type SaveWebhookMutationVariables = Exact<{
  input: WebhookInput;
}>;

export type SaveWebhookMutation = {
  __typename?: 'Mutation';
  saveWebhook: {
    __typename?: 'SaveWebhookPayload';
    webhook?: {
      __typename?: 'Webhook';
      id: string;
      url: string;
      secretKey: string;
      events: Array<WebhookEventType>;
      active: boolean;
      anonymousEvents: boolean;
    } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      property?: string | null;
      message?: string | null;
    }>;
  };
};

export type DeleteWebhookMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteWebhookMutation = {
  __typename?: 'Mutation';
  deleteWebhook: {
    __typename?: 'DeleteWebhookPayload';
    webhook?: { __typename?: 'Webhook'; id: string } | null;
    errors: Array<{
      __typename?: 'Error';
      code: string;
      property?: string | null;
      message?: string | null;
    }>;
  };
};

export type SaveMomentTemplateMutationVariables = Exact<{
  input: MomentTemplateInput;
}>;

export type SaveMomentTemplateMutation = {
  __typename?: 'Mutation';
  saveMomentTemplate: {
    __typename?: 'SaveMomentTemplatePayload';
    momentTemplate?:
      | {
          __typename: 'ConnectMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ConnectMomentOptions';
            text: string;
            windowType: WindowType;
            connectUrl: string;
          };
        }
      | {
          __typename: 'GivingMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'GivingMomentOptions';
            text: string;
            src: string;
            windowType: WindowType;
          };
        }
      | {
          __typename: 'ImageMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ImageMomentOptions';
            altText?: string | null;
            imageUrl: string;
            shareText?: string | null;
          };
        }
      | {
          __typename: 'InviteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'NextStepsMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'NextStepsMomentOptions';
            buttonText: string;
            description: string;
            iconUrl?: string | null;
            leadInText?: string | null;
            text: string;
            url?: string | null;
          };
        }
      | {
          __typename: 'PrayerMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'QuoteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
        }
      | {
          __typename: 'ResponseMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ResponseMomentOptions';
            text: string;
            buttonText: string;
            symbol: {
              __typename?: 'Symbol';
              id: string;
              name: string;
              native: string;
              unified: string;
            };
          };
        }
      | {
          __typename: 'SalvationMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'SalvationMomentOptions';
            salvationMomentFollowUpType: SalvationMomentFollowUpType;
            url?: string | null;
            labels?: {
              __typename?: 'SalvationMomentLabels';
              prompt?: string | null;
              response?: string | null;
              buttonText?: string | null;
              celebrationMessage?: string | null;
            } | null;
          };
        }
      | null;
    errors: Array<{ __typename?: 'Error'; code: string; message?: string | null }>;
  };
};

export type DeleteMomentTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteMomentTemplateMutation = {
  __typename?: 'Mutation';
  deleteMomentTemplate: {
    __typename?: 'DeleteMomentTemplatePayload';
    momentTemplate?:
      | {
          __typename: 'ConnectMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ConnectMomentOptions';
            text: string;
            windowType: WindowType;
            connectUrl: string;
          };
        }
      | {
          __typename: 'GivingMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'GivingMomentOptions';
            text: string;
            src: string;
            windowType: WindowType;
          };
        }
      | {
          __typename: 'ImageMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ImageMomentOptions';
            altText?: string | null;
            imageUrl: string;
            shareText?: string | null;
          };
        }
      | {
          __typename: 'InviteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'InviteMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'NextStepsMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'NextStepsMomentOptions';
            buttonText: string;
            description: string;
            iconUrl?: string | null;
            leadInText?: string | null;
            text: string;
            url?: string | null;
          };
        }
      | {
          __typename: 'PrayerMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'PrayerMomentOptions'; text: string; buttonText: string };
        }
      | {
          __typename: 'QuoteMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: { __typename?: 'QuoteMomentOptions'; text: string; attribution?: string | null };
        }
      | {
          __typename: 'ResponseMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'ResponseMomentOptions';
            text: string;
            buttonText: string;
            symbol: {
              __typename?: 'Symbol';
              id: string;
              name: string;
              native: string;
              unified: string;
            };
          };
        }
      | {
          __typename: 'SalvationMoment';
          id: string;
          type: MomentType;
          includedInFutureServices: boolean;
          updatedAt: any;
          options: {
            __typename?: 'SalvationMomentOptions';
            salvationMomentFollowUpType: SalvationMomentFollowUpType;
            url?: string | null;
            labels?: {
              __typename?: 'SalvationMomentLabels';
              prompt?: string | null;
              response?: string | null;
              buttonText?: string | null;
              celebrationMessage?: string | null;
            } | null;
          };
        }
      | null;
    errors: Array<{ __typename?: 'Error'; code: string; message?: string | null }>;
  };
};

export type LoadWebhookQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type LoadWebhookQuery = {
  __typename?: 'Query';
  loadWebhook?: {
    __typename?: 'Webhook';
    id: string;
    url: string;
    events: Array<WebhookEventType>;
    active: boolean;
    secretKey: string;
    updatedAt: any;
    anonymousEvents: boolean;
  } | null;
};

export type WebhookEventsQueryVariables = Exact<{
  webhookId: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type WebhookEventsQuery = {
  __typename?: 'Query';
  currentOrganization?: {
    __typename?: 'Organization';
    webhookEvents: {
      __typename?: 'WebhookEventConnection';
      totalCount: number;
      edges?: Array<{
        __typename?: 'WebhookEventEdge';
        cursor: string;
        node?: {
          __typename?: 'WebhookEvent';
          id: string;
          createdAt: any;
          status: WebhookEventStatus;
          updatedAt: any;
          response?: any | null;
          type?: WebhookEventType | null;
          responseCode?: number | null;
        } | null;
      } | null> | null;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
    };
  } | null;
};
